/* =============================================================
   Edelstahlonline24 – Geländer-Konfigurator (Shopify)
   -------------------------------------------------------------
   Ablauf:
     Geländerart → Montageposition → Geländerform
     → Maßangaben (+ Maßbestätigung) → Zusammenfassung / Warenkorb
   Kein Zuschnitt: Langmaterial (Rohre, Stäbe, Gurte, Profile) wird in
   Lieferlängen geplant, der Zuschnitt erfolgt bauseits. Ganzglasgeländer
   werden ohne Glas geliefert – der Konfigurator erstellt eine Glasliste
   (Anzahl + Richtmaße) für die bauseitige Beschaffung.
   Preise kommen live aus Shopify-Produkten (/products/<handle>.js),
   die Stückliste wird über die Cart-API (/cart/add.js) bestellt.
   Kein Build-Schritt nötig – reines ES-Modul.
   ============================================================= */

const ROOT = document.querySelector("[data-eo24-konfigurator]");

/* ----------------------------------------------------------------
   1. Katalog: Bauteile (Schlüssel = Standard-Produkt-Handle ohne Präfix)
   Fallback-Preise in Cent inkl. MwSt. – nur für Demo/Notfall,
   im Shop werden die echten Produktpreise geladen.
   ---------------------------------------------------------------- */
const KOMPONENTEN = {
  pfosten_boden_4g:         { name: "Pfosten Ø 42,4 mm mit Bodenplatte, 4 Gewinde",   einheit: "Stk", preis: 8900 },
  pfosten_boden_5g:         { name: "Pfosten Ø 42,4 mm mit Bodenplatte, 5 Gewinde",   einheit: "Stk", preis: 8900 },
  pfosten_boden_6g:         { name: "Pfosten Ø 42,4 mm mit Bodenplatte, 6 Gewinde",   einheit: "Stk", preis: 8900 },
  pfosten_boden_7g:         { name: "Pfosten Ø 42,4 mm mit Bodenplatte, 7 Gewinde",   einheit: "Stk", preis: 8900 },
  pfosten_seitlich_4g:      { name: "Pfosten Ø 42,4 mm seitlich, 4 Gewinde",          einheit: "Stk", preis: 9900 },
  pfosten_seitlich_5g:      { name: "Pfosten Ø 42,4 mm seitlich, 5 Gewinde",          einheit: "Stk", preis: 9900 },
  pfosten_seitlich_6g:      { name: "Pfosten Ø 42,4 mm seitlich, 6 Gewinde",          einheit: "Stk", preis: 9900 },
  pfosten_seitlich_7g:      { name: "Pfosten Ø 42,4 mm seitlich, 7 Gewinde",          einheit: "Stk", preis: 9900 },
  relingplus_stuetze:       { name: "Handlaufstütze abgewinkelt (Reling-PLUS)",       einheit: "Stk", preis: 1450 },
  handlaufstuetze:          { name: "Handlaufstütze für Rundrohr Ø 42,4 mm",          einheit: "Stk", preis: 1650 },
  // Eckpfosten bei Aufbodenmontage (F60704-240). "handle" ist der Standard-Handle, solange im
  // JSON-Feld der Section keine eigene Zuordnung steht (das JSON hat immer Vorrang).
  handlaufstuetze_eck:      { name: "Handlaufstütze 90° für Eckpfosten Ø 42,4 mm",    einheit: "Stk", preis: 848,
    handle: "handlaufstutze-o-12mm-verschraubt-90-zur-pfostenbefestigung-fur-o-42-4-x-2-0mm-pfosten-an-rohr-o-42-4mm" },
  handlaufrohr:             { name: "Handlaufrohr Ø 42,4 mm, V2A K240",               einheit: "Stk", laengen: true, preisProCm: 74 },
  handlauf_endkappe:        { name: "Endkappe Ø 42,4 mm gewölbt",                     einheit: "Stk", preis: 690 },
  handlauf_eckverbinder:    { name: "Eckverbinder 90° Handlauf (Gehrung)",             einheit: "Stk", preis: 2490 },
  handlauf_verbinder:       { name: "Rohrverbinder Ø 42,4 mm (Stoß)",                 einheit: "Stk", preis: 590 },
  fuellstab:                { name: "Füllstab Ø 12 mm, V2A K240",                     einheit: "Stk", laengen: true, preisProCm: 22 },
  stabhalter:               { name: "Stabhalter Ø 12 mm für Pfosten",                 einheit: "Stk", preis: 390 },
  // Querstabhalter am Eckpfosten (Aufbodenmontage). Außenecke = Standard-L/U-Form (Balkonecke),
  // Innenecke = Geländer knickt vom Gebäude weg (negativer Winkel in der Frei-Form).
  stabhalter_eck_aussen:    { name: "Querstabhalter 90° Außenecke Ø 12 mm",           einheit: "Stk", preis: 681,
    handle: "querstabhalter-90-aussenecke-anschluss-fur-o-42-4mm-rohr-fur-stab-o-12mm-aus-v2a" },
  stabhalter_eck_innen:     { name: "Querstabhalter 90° Innenecke Ø 12 mm",           einheit: "Stk", preis: 796,
    handle: "querstabhalter-90-innennecke-anschluss-fur-o-42-4mm-rohr-fur-stab-o-12mm-aus-v2a" },
  fuellstab_endkappe:       { name: "Endkappe flach Ø 12 mm für Querstab",            einheit: "Stk", preis: 149,
    handle: "endkappe-flach-fur-o-12mm-stab-zum-kleben" },
  fuellstab_eckverbinder:   { name: "Eckverbinder Füllstab Ø 12 mm",                  einheit: "Stk", preis: 1290 },
  fuellstab_verbinder:      { name: "Stabverbinder Ø 12 mm (Stoß)",                   einheit: "Stk", preis: 290 },
  wandhalter:               { name: "Wandhalter Ø 42,4 mm mit Rosette",               einheit: "Stk", preis: 1650 },
  ggl_profil_boden:         { name: "Alu-Bodenprofil Ganzglas 0,5 kN, aufgeschraubt",  einheit: "Stk", laengen: true, preisProCm: 195 },
  ggl_profil_seitlich:      { name: "Alu-Bodenprofil Ganzglas 0,5 kN, seitlich",       einheit: "Stk", laengen: true, preisProCm: 215 },
  ggl_profil_endkappe_boden:    { name: "Endkappe Bodenprofil aufgeschraubt",         einheit: "Stk", preis: 995 },
  ggl_profil_endkappe_seitlich: { name: "Endkappe Bodenprofil seitlich",              einheit: "Stk", preis: 995 },
  ggl_verglasungsset:       { name: "Verglasungsset je Scheibe (Keile, Gummi, Klemmleisten)", einheit: "Stk", preis: 2490 },
  ggl_handlauf_rund:        { name: "Glaskanten-Handlauf rund Ø 42,4 mm",             einheit: "Stk", laengen: true, preisProCm: 92 },
  ggl_handlauf_eckig:       { name: "Glaskanten-Handlauf eckig 40 × 40 mm",           einheit: "Stk", laengen: true, preisProCm: 84 },
  ggl_handlauf_endkappe_rund:  { name: "Endkappe Glaskanten-Handlauf rund",           einheit: "Stk", preis: 745 },
  ggl_handlauf_endkappe_eckig: { name: "Endkappe Glaskanten-Handlauf eckig",          einheit: "Stk", preis: 745 },
  ggl_handlauf_eck_rund:    { name: "Verlaufsecke 90° Glaskanten-Handlauf rund",     einheit: "Stk", preis: 2990 },
  ggl_handlauf_eck_eckig:   { name: "Verlaufsecke 90° Glaskanten-Handlauf eckig",    einheit: "Stk", preis: 2990 },
  ggl_handlauf_verb_rund:   { name: "Rohrverbinder Glaskanten-Handlauf rund (Stoß)", einheit: "Stk", preis: 790 },
  ggl_handlauf_verb_eckig:  { name: "Rohrverbinder Glaskanten-Handlauf eckig (Stoß)",einheit: "Stk", preis: 790 },
  konfigurator_produkt:     { name: "Geländer-Konfiguration",                         einheit: "Stk", preis: 100 },
};
const LIEFERLAENGEN_STD = [100, 150, 200, 250, 300];

const PRODUKTE = [
  { id: "reling",      name: "Relinggeländer",       desc: "Fünf waagerechte Füllstäbe Ø 12 mm. Zeitlos, schlank, das meistverkaufte System." },
  // Reling-PLUS ist vorerst deaktiviert. Die gesamte Logik (Stückliste, Handlaufhalter 50372-240,
  // 3D-Darstellung) bleibt im Code erhalten – zum Wiederaktivieren genügt es, diese Zeile
  // einzukommentieren. Ältere Entwurfs-Links mit dieser Geländerart fallen sauber auf die
  // Standardauswahl zurück, statt einen Fehler zu erzeugen.
  // { id: "relingplus",  name: "Reling-PLUS-Geländer", desc: "Wie Reling, aber mit nach innen versetztem Handlauf – erschwert Kleinkindern das Überklettern." },
  { id: "ganzglas",    name: "Ganzglasgeländer",     desc: "Rahmenlos: Alu-Bodenprofil und Glaskanten-Handlauf. Glas (VSG) beschaffen Sie bauseits – wir liefern die Glasliste dazu." },
  { id: "handlauf",    name: "Wandhandlauf",         desc: "Handlauf Ø 42,4 mm zur Wandmontage – für Treppen innen und außen." },
];

const FORMEN = [
  { id: "gerade", name: "Gerade",     desc: "Eine Seite",            segmente: [300] },
  { id: "l",      name: "L-Form",     desc: "Zwei Seiten, eine Ecke", segmente: [300, 200] },
  { id: "u",      name: "U-Form",     desc: "Drei Seiten, zwei Ecken", segmente: [200, 300, 200] },
  // Frei-Form deaktiviert, da nicht realisierbar. Logik bleibt im Code; zum Reaktivieren die naechste Zeile einkommentieren.
  // { id: "frei",   name: "Frei-Form",  desc: "Beliebige Seiten & Winkel", segmente: [300, 150] },
];

/* ----------------------------------------------------------------
   2. Helfer
   ---------------------------------------------------------------- */
const S = {}; // Settings (aus Liquid)
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const rad = (d) => (d * Math.PI) / 180;
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const fmtEuro = (cents) => new Intl.NumberFormat(S.locale || "de-DE", { style: "currency", currency: S.currency || "EUR" }).format((cents || 0) / 100);
const fmtM = (cm) => (cm / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " m";
const dist = (a, b) => Math.hypot(b.x - a.x, b.y - a.y);

function b64url(str) { return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); }
function unb64url(str) { str = str.replace(/-/g, "+").replace(/_/g, "/"); while (str.length % 4) str += "="; return decodeURIComponent(escape(atob(str))); }
function konfigId(cfg) {
  const s = JSON.stringify(cfg, ["typ", "handlauf", "montage", "form", "segmente", "l", "w"]);
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
  return "EO24-" + h.toString(36).toUpperCase().padStart(7, "0").slice(-7);
}

/* ----------------------------------------------------------------
   3. Geometrie
   Die Außenkante der Bodenplatte wird als Polylinie aus Segmenten
   (Länge + Winkel zum nächsten Segment) aufgebaut. Positive Winkel
   drehen nach links (Innenecke), das Gebäude liegt links der Kante.
   Die Geländerachse ist die um d versetzte Polylinie.
   ---------------------------------------------------------------- */
function offsetPolyline(pts, d) {
  const n = pts.length;
  if (n < 2) return pts.map((p) => ({ ...p }));
  const segs = [];
  for (let i = 0; i < n - 1; i++) {
    const dx = pts[i + 1].x - pts[i].x, dy = pts[i + 1].y - pts[i].y, l = Math.hypot(dx, dy) || 1;
    const nx = -dy / l, ny = dx / l; // Normale nach links
    segs.push({ ax: pts[i].x + nx * d, ay: pts[i].y + ny * d, bx: pts[i + 1].x + nx * d, by: pts[i + 1].y + ny * d });
  }
  const out = [{ x: segs[0].ax, y: segs[0].ay }];
  for (let i = 1; i < n - 1; i++) {
    const p = segs[i - 1], q = segs[i];
    const r1x = p.bx - p.ax, r1y = p.by - p.ay, r2x = q.bx - q.ax, r2y = q.by - q.ay;
    const den = r1x * r2y - r1y * r2x;
    if (Math.abs(den) < 1e-6) { out.push({ x: q.ax, y: q.ay }); continue; }
    const t = ((q.ax - p.ax) * r2y - (q.ay - p.ay) * r2x) / den;
    out.push({ x: p.ax + r1x * t, y: p.ay + r1y * t });
  }
  out.push({ x: segs[n - 2].bx, y: segs[n - 2].by });
  return out;
}

function achsversatz(cfg) {
  if (cfg.typ === "handlauf") return 0;
  if (cfg.typ === "ganzglas") return cfg.montage === "seitlich" ? -3.5 : 4;
  // -6,36 cm: Die Anschraubplatte des Original-Pfostens 40532-240 liegt 63,6 mm vor der Rohrachse;
  // damit sitzt sie plan an der Stirnseite der Bodenplatte (früher pauschal -7 cm geschätzt).
  return cfg.montage === "seitlich" ? -6.36 : 6;
}

// Verlängert eine Polylinie an den beiden freien Enden geradlinig um cm (für den Handlaufüberstand
// über die äußeren Pfosten hinaus – dort sitzt die Handlaufstütze, der Handlauf kragt aus).
function endenVerlaengern(pts, cm) {
  if (pts.length < 2 || !cm) return pts;
  const out = pts.map((p) => ({ ...p })), n = pts.length;
  const d0 = dist(pts[0], pts[1]) || 1;
  out[0] = { x: pts[0].x - ((pts[1].x - pts[0].x) / d0) * cm, y: pts[0].y - ((pts[1].y - pts[0].y) / d0) * cm };
  const dn = dist(pts[n - 2], pts[n - 1]) || 1;
  out[n - 1] = { x: pts[n - 1].x + ((pts[n - 1].x - pts[n - 2].x) / dn) * cm, y: pts[n - 1].y + ((pts[n - 1].y - pts[n - 2].y) / dn) * cm };
  return out;
}

function berechneGeometrie(cfg) {
  const isHand = cfg.typ === "handlauf", isGGL = cfg.typ === "ganzglas";
  const segIn = isHand ? [{ l: cfg.segmente[0].l, w: 0 }] : cfg.segmente;
  const kante = [{ x: 0, y: 0 }];
  let ang = 0;
  segIn.forEach((s, i) => {
    const l = clamp(Number(s.l) || 0, 1, 3000);
    const last = kante[kante.length - 1];
    kante.push({ x: last.x + Math.cos(ang) * l, y: last.y + Math.sin(ang) * l });
    if (i < segIn.length - 1) ang += rad(clamp(Number(s.w) || 0, -170, 170));
  });
  const d = achsversatz(cfg);
  const linie = offsetPolyline(kante, d);
  const maxAb = S.maxPfostenabstand || 130, maxGl = S.maxGlasbreite || 120;
  // Seitliche Montage: Auf der Ecke selbst steht kein Pfosten. Stattdessen sitzt je ein Pfosten
  // vor und hinter der Ecke, im Abstand eckAb (entlang der Geländerachse gemessen).
  const isSeitPfosten = !isHand && !isGGL && cfg.montage === "seitlich";
  const eckAb = isSeitPfosten ? Math.max(5, Number(S.eckAbstandSeitlich ?? 20)) : 0;
  const segs = [], pfosten = [];
  let gesamt = 0;
  const seen = new Set();
  const addPost = (p, nx, ny, ecke) => {
    const k = Math.round(p.x) + ":" + Math.round(p.y);
    if (seen.has(k)) {
      // Der Eckpunkt wurde schon als letzter Punkt des vorherigen Segments angelegt – damals ohne
      // Eck-Markierung. Sie wird deshalb hier nachgetragen, statt den Eintrag zu verwerfen.
      if (ecke) { const vorh = pfosten.find((q) => Math.round(q.x) + ":" + Math.round(q.y) === k); if (vorh) vorh.ecke = true; }
      return;
    }
    seen.add(k); pfosten.push({ x: p.x, y: p.y, nx, ny, ecke });
  };
  for (let i = 0; i < linie.length - 1; i++) {
    const a = linie[i], b = linie[i + 1], len = dist(a, b);
    const dx = (b.x - a.x) / (len || 1), dy = (b.y - a.y) / (len || 1);
    const nx = -dy, ny = dx;
    gesamt += len;
    // Pfostenbereich der Seite: bei seitlicher Montage an jeder Ecke um eckAb eingerückt.
    // Ist eine Seite dafür zu kurz, bleibt sie in der Mitte mindestens 10 cm breit.
    let s0 = isSeitPfosten && i > 0 ? eckAb : 0, s1 = isSeitPfosten && i < linie.length - 2 ? len - eckAb : len;
    if (s1 - s0 < 10) { const m = (s0 + s1) / 2; s0 = Math.max(0, m - 5); s1 = Math.min(len, m + 5); }
    const spann = s1 - s0;
    const felder = Math.max(1, Math.ceil((isSeitPfosten ? spann : len) / (isGGL ? maxGl : maxAb)));
    const feldLaenge = (isSeitPfosten ? spann : len) / felder;
    const pts = [];
    for (let k = 0; k <= felder; k++) pts.push({ x: a.x + dx * (s0 + feldLaenge * k), y: a.y + dy * (s0 + feldLaenge * k) });
    segs.push({ a, b, len, dx, dy, nx, ny, felder, feldLaenge, pts });
    if (!isHand && !isGGL) pts.forEach((p, k) => {
      const ecke = k === 0 && i > 0 && !isSeitPfosten;
      addPost(p, nx, ny, ecke);
      if (ecke) {
        // Winkelhalbierende der Ecke merken: Sie zeigt vom Pfosten zur Kante der Bodenplatte und
        // bestimmt, wie der Eckhalter ausgerichtet wird. Ergibt sich aus den Normalen der beiden
        // angrenzenden Segmente (die vorige steckt im bereits angelegten Pfosten).
        const q = pfosten.find((x) => Math.round(x.x) === Math.round(p.x) && Math.round(x.y) === Math.round(p.y));
        if (q) {
          const bx = (q.nx || 0) + nx, by = (q.ny ?? 1) + ny, bl = Math.hypot(bx, by) || 1;
          q.bx = bx / bl; q.by = by / bl;
          // Knickrichtung: positiver Winkel = Balkon-Außenecke (Standard bei L/U), negativ = Innenecke
          q.eckWinkel = Number(segIn[i - 1]?.w) || 0;
          // Winkelhalbierende der beiden Handlauf-Arme (zurück entlang der vorigen Seite und weiter
          // entlang der nächsten). Danach wird die Handlaufstütze 90° (60704-240) ausgerichtet.
          const hx = -(q.ny ?? 1) + dx, hy = (q.nx || 0) + dy, hl = Math.hypot(hx, hy) || 1;
          q.hx = hx / hl; q.hy = hy / hl;
        }
      }
    });
  }
  // Wandhalter beim Handlauf: Randabstand 15 cm, max. 100 cm Abstand
  if (isHand) {
    const len = gesamt, inner = Math.max(len - 30, 0);
    const n = Math.max(2, Math.ceil(inner / 100) + 1);
    for (let k = 0; k < n; k++) pfosten.push({ x: 15 + (inner * k) / (n - 1), y: 0, nx: 0, ny: 1 });
  }
  // Tiefe der Bodenplatte für die Darstellung
  let tiefe = 150;
  for (let i = 1; i < segIn.length - 1; i++) tiefe = Math.min(tiefe, Math.max(30, (Number(segIn[i].l) || 0) / 2 - 8));
  const ecken = Math.max(0, segIn.length - 1);
  // Handlauf-Überstand: bei Pfostengeländern (nicht Wandhandlauf, nicht Ganzglas) ragt der Handlauf
  // über die äußeren Pfosten hinaus – er ist dort mit Handlaufstützen befestigt, nicht auf den Pfosten aufgesetzt.
  const ueberstand = !isHand && !isGGL ? Math.max(0, Number(S.handlaufUeberstand ?? 5)) : 0;
  const linieHL = ueberstand ? endenVerlaengern(linie, ueberstand) : linie;
  const segsHL = ueberstand ? segs.map((sg, i, arr) => ({ ...sg, len: sg.len + (i === 0 ? ueberstand : 0) + (i === arr.length - 1 ? ueberstand : 0) })) : segs;
  return { kante, linie, linieHL, segs, segsHL, ueberstand, pfosten, gesamt, ecken, tiefe, d };
}

/* ----------------------------------------------------------------
   4. Stückliste
   ---------------------------------------------------------------- */
const PREISE = {};        // key -> { cents, variantId, handle, ok, laengen: { [cm]: { cents, variantId } } }
const PREIS_LADEN = {};   // key -> Promise

// Zuordnung eines Bauteils zu Shop-Produkten. Zwei Schreibweisen sind erlaubt:
//   "handlaufrohr": "mein-rohr"                      -> ein Produkt, Lieferlängen über Varianten
//   "handlaufrohr": { "200": "rohr-2m", "300": "..." } -> je Lieferlänge ein eigenes Produkt
// Die zweite Form braucht man, wenn der Shop jede Länge als eigenständigen Artikel führt.
function zuordnung(key) { return (S.komponenten || {})[key]; }
function istLaengenMap(key) {
  const z = zuordnung(key);
  return z && typeof z === "object" && !Array.isArray(z);
}
function handleFuer(key) {
  const z = zuordnung(key);
  if (istLaengenMap(key)) {
    // Für Anzeigezwecke: der Handle der größten hinterlegten Länge
    const ls = Object.keys(z).map(Number).filter((x) => x > 0).sort((a, b) => b - a);
    return ls.length ? z[ls[0]] : (S.handlePrefix || "eo24-") + key.replace(/_/g, "-");
  }
  return z || KOMPONENTEN[key]?.handle || (S.handlePrefix || "eo24-") + key.replace(/_/g, "-");
}
// Handle für eine bestimmte Lieferlänge (nur bei der Längen-Schreibweise)
function handleFuerLaenge(key, l) {
  const z = zuordnung(key);
  return istLaengenMap(key) ? z[String(l)] || z[l] : null;
}
function stdLaengen() {
  const l = (S.lieferlaengen || LIEFERLAENGEN_STD).map(Number).filter((x) => x > 0).sort((a, b) => a - b);
  return l.length ? l : LIEFERLAENGEN_STD;
}
function fallbackEintrag(key) {
  const k = KOMPONENTEN[key], e = { cents: k.preis ?? 0, variantId: null, handle: handleFuer(key), ok: false };
  if (k.laengen) { e.laengen = {}; stdLaengen().forEach((l) => (e.laengen[l] = { cents: k.preisProCm * l, variantId: null })); }
  return e;
}
function preisVon(key) { return (PREISE[key] || fallbackEintrag(key)).cents; }
// Artikelnummer einer Stücklistenzeile – bei Längenartikeln die der konkreten Variante.
// Nur zur Kontrolle/zum Abgleich; die Verbindung zum Shop läuft immer über den Handle.
function skuVon(p) {
  const e = PREISE[p.key];
  if (!e || !e.ok) return "";
  if (p.laenge && e.laengen) return e.laengen[p.laenge]?.sku || "";
  return e.sku || "";
}
function laengenVon(key) {
  const e = PREISE[key];
  if (e?.laengen && Object.keys(e.laengen).length) return Object.keys(e.laengen).map(Number).sort((a, b) => a - b);
  // Ist je Länge ein eigenes Produkt hinterlegt, gelten genau diese Längen – auch schon bevor die
  // Preise geladen sind. Sonst würde mit Längen geplant, die es im Shop gar nicht gibt.
  if (istLaengenMap(key)) {
    const ls = Object.keys(zuordnung(key)).map(Number).filter((x) => x > 0).sort((a, b) => a - b);
    if (ls.length) return ls;
  }
  return stdLaengen();
}
function laengenEintrag(key, l) { return (PREISE[key]?.laengen || fallbackEintrag(key).laengen)[l] || { cents: KOMPONENTEN[key].preisProCm * l, variantId: null }; }

function ladePreis(key) {
  if (!S.shop) { PREISE[key] = { ...fallbackEintrag(key), demo: true }; return Promise.resolve(); }
  if (PREIS_LADEN[key]) return PREIS_LADEN[key];
  const handle = handleFuer(key), k = KOMPONENTEN[key];
  const hol = (h) => fetch(`${(S.rootUrl || "/").replace(/\/?$/, "/")}products/${h}.js`, { headers: { Accept: "application/json" } })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.status))));
  // Variante A: je Lieferlänge ein eigenes Produkt – alle nacheinander abfragen
  if (k.laengen && istLaengenMap(key)) {
    const z = zuordnung(key);
    const paare = Object.keys(z).map(Number).filter((x) => x > 0).sort((a, b) => a - b);
    PREIS_LADEN[key] = Promise.all(paare.map((l) =>
      hol(z[String(l)] || z[l]).then((p) => {
        const v = (p.variants || []).find((x) => x.available !== false) || p.variants?.[0];
        return v ? { l, cents: v.price, variantId: v.id, sku: v.sku || "", titel: p.title } : null;
      }).catch(() => null)))
      .then((treffer) => {
        const laengen = {};
        treffer.filter(Boolean).forEach((t) => { laengen[t.l] = { cents: t.cents, variantId: t.variantId, sku: t.sku }; });
        const erster = treffer.find(Boolean);
        PREISE[key] = { cents: 0, variantId: null, handle, ok: Object.keys(laengen).length > 0,
          laengen, titel: erster?.titel || k.name, sku: erster?.sku || "" };
      })
      .catch(() => { PREISE[key] = fallbackEintrag(key); })
      .finally(() => { renderPreis(); if (state.open === "fertig") renderSteps(); });
    return PREIS_LADEN[key];
  }
  PREIS_LADEN[key] = fetch(`${(S.rootUrl || "/").replace(/\/?$/, "/")}products/${handle}.js`, { headers: { Accept: "application/json" } })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
    .then((p) => {
      if (k.laengen) {
        // Lieferlängen aus den Varianten lesen: Titel/Option enthält die Länge (z. B. "200 cm", "2 m", "150")
        const laengen = {};
        (p.variants || []).forEach((v) => {
          const t = [v.title, v.option1, v.option2, v.option3].filter(Boolean).join(" ");
          const m = t.match(/(\d+(?:[.,]\d+)?)\s*(cm|m)\b/i) || t.match(/(\d{2,4})/);
          if (!m) return;
          let l = parseFloat(m[1].replace(",", ".")); if ((m[2] || "").toLowerCase() === "m") l *= 100;
          l = Math.round(l); if (l > 0 && v.available !== false) laengen[l] = { cents: v.price, variantId: v.id, sku: v.sku || "" };
        });
        PREISE[key] = { cents: 0, variantId: null, handle, ok: Object.keys(laengen).length > 0, laengen, titel: p.title, sku: (p.variants || [])[0]?.sku || "" };
      } else {
        const v = (p.variants || []).find((x) => x.available !== false) || p.variants?.[0];
        PREISE[key] = { cents: v ? v.price : k.preis, variantId: v ? v.id : null, handle, ok: !!v, titel: p.title, sku: v?.sku || "" };
      }
    })
    .catch(() => { PREISE[key] = fallbackEintrag(key); })
    .finally(() => { renderPreis(); if (state.open === "fertig") renderSteps(); });
  return PREIS_LADEN[key];
}

/* Glasliste (bauseits) für Ganzglasgeländer: Anzahl und Richtmaße je Seite */
function glasliste(cfg, geo) {
  const H = S.gelaenderhoehe || 100;
  const hoehe = cfg.montage === "seitlich" ? H - 2 + 10 : H - 2 - 13 + 10; // Handlauf 2 cm, Profil 13 cm hoch, 10 cm Einstand
  const list = [];
  geo.segs.forEach((sg, i) => list.push({ seite: i + 1, anzahl: sg.felder, breite: Math.floor(sg.feldLaenge - 1), hoehe }));
  return { list, anzahl: list.reduce((q, x) => q + x.anzahl, 0), hoehe };
}

/* Lieferlängen-Planung: welche Standardlängen decken eine Seite ab? */
// Zuschnittplan für einen Längenartikel. Sind die Preise der einzelnen Lieferlängen bekannt, wird
// die GÜNSTIGSTE Kombination gesucht, nicht die mit den wenigsten Stücken – längere Stangen haben
// oft einen besseren Meterpreis, dafür kostet jeder Stoß einen Verbinder. Beides wird verrechnet.
// Ohne bekannte Preise bleibt es beim bisherigen Verfahren (möglichst wenige Stücke).
function zuschnittPlan(len, laengen, preisFuer, verbinderCents = 0) { // eslint-disable-line no-param-reassign
  len = Math.ceil(len);
  const sortiert = [...laengen].sort((a, b) => a - b);
  const max = sortiert[sortiert.length - 1];
  if (!(len > 0) || !max) return [];

  let preise = preisFuer ? sortiert.map(preisFuer) : null;
  if (!preise || preise.some((c) => !(c > 0))) {
    // Solange keine Preise vorliegen, wird nach Materialeinsatz geplant: die Kombination mit dem
    // geringsten Verschnitt. Wichtig, seit es 6-m-Stangen gibt – das frühere Verfahren "kleinste
    // Länge, die reicht" hätte für 3 m Geländer eine ganze 6-m-Stange gewählt.
    preise = sortiert.map((l) => l * 100);
    verbinderCents = 1; // minimaler Aufschlag je Stück: bei gleichem Verschnitt gewinnt weniger Stückzahl
  }

  // Jedes Stück bekommt den Verbinderpreis aufgeschlagen; am Ende wird einer wieder abgezogen,
  // denn bei n Stücken gibt es nur n-1 Stöße.
  const kosten = new Array(len + 1).fill(Infinity);
  const wahl = new Array(len + 1).fill(-1);
  kosten[0] = 0;
  for (let i = 1; i <= len; i++) {
    for (let j = 0; j < sortiert.length; j++) {
      const vor = Math.max(0, i - sortiert[j]);
      if (kosten[vor] === Infinity) continue;
      const k = kosten[vor] + preise[j] + verbinderCents;
      if (k < kosten[i]) { kosten[i] = k; wahl[i] = j; }
    }
  }
  if (wahl[len] < 0) { // sollte nicht vorkommen, aber lieber absichern
    const teile = []; let rest = len;
    while (rest > max) { teile.push(max); rest -= max; }
    teile.push(sortiert.find((l) => l >= rest) ?? max);
    return teile;
  }
  const teile = [];
  for (let i = len; i > 0; ) { const j = wahl[i]; teile.push(sortiert[j]); i = Math.max(0, i - sortiert[j]); }
  return teile.sort((a, b) => b - a);
}

function stueckliste(cfg, geo) {
  const pos = [];
  const add = (key, menge, hinweis) => {
    menge = Math.ceil(menge);
    if (!(menge > 0)) return;
    const k = KOMPONENTEN[key], e = PREISE[key], einzel = preisVon(key);
    pos.push({ key, name: k.name, einheit: k.einheit, menge, einzel, summe: einzel * menge, hinweis, variantId: e?.variantId ?? null, ok: !!e?.ok, geladen: !!e });
  };
  // Langmaterial in Lieferlängen: je Seite planen, gleiche Längen zusammenfassen
  const addLang = (key, faktor, label, segsUse = geo.segs, verbinderKey = null) => {
    const laengen = laengenVon(key), k = KOMPONENTEN[key];
    const counts = {};
    let stoesse = 0;
    // Preis je Lieferlänge und Preis eines Verbinders, damit der Zuschnitt nach Kosten plant
    const preisFuer = (l) => laengenEintrag(key, l).cents;
    const verbCents = verbinderKey ? preisVon(verbinderKey) : 0;
    segsUse.forEach((sg) => {
      const plan = zuschnittPlan(sg.len, laengen, preisFuer, verbCents);
      stoesse += (plan.length - 1) * faktor;
      plan.forEach((l) => (counts[l] = (counts[l] || 0) + faktor));
    });
    Object.keys(counts).map(Number).sort((a, b) => b - a).forEach((l) => {
      const e = laengenEintrag(key, l), menge = counts[l];
      pos.push({ key, laenge: l, name: `${k.name}, ${l} cm`, einheit: "Stk", menge, einzel: e.cents, summe: e.cents * menge,
        hinweis: label, variantId: e.variantId, ok: !!e.variantId, geladen: !!PREISE[key] });
    });
    return { stoesse };
  };
  if (!cfg.typ) return pos;
  const nP = geo.pfosten.length, E = geo.ecken, seit = cfg.montage === "seitlich", t = cfg.typ;
  const schraeg = cfg.segmente.slice(0, -1).filter((sg) => Math.abs(Number(sg.w)) !== 90).length;
  const eckHinweis = schraeg ? `${schraeg} Ecke${schraeg > 1 ? "n" : ""} ≠ 90° – Sonderwinkel bitte anfragen` : "";

  if (t === "handlauf") {
    const hl = addLang("handlaufrohr", 1, `Zuschnitt bauseits auf ${Math.ceil(geo.gesamt)} cm`, geo.segs, "handlauf_verbinder");
    add("handlauf_verbinder", hl.stoesse, "Stoß im Handlauf");
    add("wandhalter", nP);
    add("handlauf_endkappe", 2);
    return pos;
  }
  if (t === "ganzglas") {
    const seitenG = "Zuschnitt bauseits: " + geo.segs.map((sg, i) => `Seite ${i + 1} ${Math.ceil(sg.len)} cm`).join(", ");
    addLang(seit ? "ggl_profil_seitlich" : "ggl_profil_boden", 1, seitenG);
    // Je Profil zwei Endkappen (Anfang und Ende). An Ecken werden die Profile auf Gehrung
    // geschnitten – dafür gibt es kein Verbindungsstück.
    add(`ggl_profil_endkappe_${seit ? "seitlich" : "boden"}`, 2);
    const gl = glasliste(cfg, geo);
    add("ggl_verglasungsset", gl.anzahl, `${gl.anzahl} Scheibe${gl.anzahl > 1 ? "n" : ""} – Glas bauseits`);
    const hl = addLang(cfg.handlauf === "eckig" ? "ggl_handlauf_eckig" : "ggl_handlauf_rund", 1, seitenG, geo.segs,
      cfg.handlauf === "eckig" ? "ggl_handlauf_verb_eckig" : "ggl_handlauf_verb_rund");
    add(`ggl_handlauf_endkappe_${cfg.handlauf === "eckig" ? "eckig" : "rund"}`, 2);
    // Eckstück und Stoßverbinder gibt es je Handlaufform als eigenen Artikel
    const hlForm = cfg.handlauf === "eckig" ? "eckig" : "rund";
    add(`ggl_handlauf_eck_${hlForm}`, E, eckHinweis);
    add(`ggl_handlauf_verb_${hlForm}`, hl.stoesse, "Stoß im Handlauf");
    return pos;
  }
  // Pfosten je nach gewählter Stabanzahl – die Gewindeanzahl bestimmt den Artikel.
  // Seitliche Montage: Pfosten stehen vor und hinter der Ecke, nie auf der Ecke (siehe Geometrie).
  // Aufbodenmontage: Auf jeder Ecke steht ein Eckpfosten. Dort enden die Querstäbe von beiden
  // Seiten im Querstabhalter 90° (statt 50400-240A) und bekommen je eine Endkappe; oben sitzt die
  // Handlaufstütze 90° (60704-240 statt 60722-240). Das flexible Stab-Verbindungsstück entfällt dort.
  const nG = stabAnzahl(cfg) || 5;
  const eckP = geo.pfosten.filter((p) => p.ecke);
  const nEck = eckP.length, nEckAussen = eckP.filter((p) => (p.eckWinkel ?? 90) >= 0).length, nEckInnen = nEck - nEckAussen;
  add(`${seit ? "pfosten_seitlich" : "pfosten_boden"}_${nG}g`, nP, nEck ? `davon ${nEck} Eckpfosten` : "");
  if (t === "relingplus") add("relingplus_stuetze", nP);
  else {
    add("handlaufstuetze", nP - nEck, "verbindet Handlauf und Pfosten");
    add("handlaufstuetze_eck", nEck, "am Eckpfosten");
  }
  const seiten = "Zuschnitt bauseits: " + geo.segs.map((sg, i) => `Seite ${i + 1} ${Math.ceil(sg.len)} cm`).join(", ");
  const hlLabel = seiten + (geo.ueberstand ? ` · Handlauf ${geo.ueberstand} cm länger als die äußeren Pfosten (Überstand an der Handlaufstütze)` : "");
  const hl = addLang("handlaufrohr", 1, hlLabel, geo.segsHL, "handlauf_verbinder");
  add("handlauf_endkappe", 2);
  add("handlauf_eckverbinder", E, eckHinweis);
  add("handlauf_verbinder", hl.stoesse, "Stoß im Handlauf");
  const nStaebe = stabAnzahl(cfg);
  const st = addLang("fuellstab", nStaebe, nStaebe + " Stäbe je Seite – " + seiten, geo.segs, "fuellstab_verbinder");
  add("stabhalter", nStaebe * (nP - nEck));
  add("stabhalter_eck_aussen", nStaebe * nEckAussen, "am Eckpfosten (Außenecke)");
  add("stabhalter_eck_innen", nStaebe * nEckInnen, "am Eckpfosten (Innenecke)");
  add("fuellstab_endkappe", 2 * nStaebe * nEck, "Querstabenden am Eckpfosten");
  // Flexibles Verbindungsstück nur an Ecken ohne Eckpfosten (seitliche Montage)
  add("fuellstab_eckverbinder", nStaebe * Math.max(0, E - nEck));
  add("fuellstab_verbinder", st.stoesse, "Stöße in den Füllstäben");
  return pos;
}
const gesamtpreis = (bom) => bom.reduce((s, p) => s + p.summe, 0);

/* ----------------------------------------------------------------
   5. Zustand
   ---------------------------------------------------------------- */
const DEFAULT_CFG = () => ({
  typ: null, handlauf: "rund", montage: "aufgeschraubt", form: "gerade", staebe: 5, segmente: [{ l: 300, w: 90 }], bestaetigt: false,
});
const state = { cfg: DEFAULT_CFG(), open: "typ", done: new Set(), confirming: false, tab: "3d", fehler: "", sende: false };

// Nur Pfostengeländer mit Stabfüllung haben wählbare Querstäbe.
function hatStaebe(cfg) { return cfg.typ === "reling" || cfg.typ === "relingplus"; }
// Erlaubte Stabanzahlen.
const STAB_OPTIONEN = [4, 5, 6, 7];
const stabAnzahl = (cfg) => (hatStaebe(cfg) ? clamp(Number(cfg.staebe) || 5, 4, 7) : 0);
// Gewindepositionen der Original-Pfosten (40532-240), gemessen in mm UNTERHALB der Pfostenoberkante.
// Aus den STEP-Dateien der vier Varianten ausgemessen – die Querstäbe sitzen dort, wo die Pfosten
// tatsächlich Gewinde haben, nicht auf einem frei gewählten Raster. Bezug ist die Pfostenoberkante,
// damit dieselben Höhen für aufgeschraubte und seitliche Montage gelten.
const STAB_GEWINDE = {
  4: [111, 303, 496, 688],
  5: [79, 239, 400, 560, 720],
  6: [56, 194, 331, 468, 605, 743],
  7: [39, 159, 279, 400, 520, 640, 760],
};
// Höhen der Querstäbe in Metern, gemessen von der Bodenplatte, für eine gegebene Pfostenoberkante.
function stabHoehenAbsolut(n, postTop) {
  return (STAB_GEWINDE[n] || STAB_GEWINDE[5]).map((d) => postTop - d / 1000).sort((a, b) => a - b);
}
// Anteilige Höhen – nur für das Auswahl-Icon, damit es die echte Aufteilung zeigt.
function stabHoehen(n) {
  const d = STAB_GEWINDE[n] || STAB_GEWINDE[5], L = 1.19;
  return d.map((x) => 1 - x / 1000 / L).sort((a, b) => a - b);
}

function schritte(cfg) {
  const rail = (cfg.typ || "reling") !== "handlauf";
  return [
    { id: "typ", title: "Geländerart" },
    cfg.typ === "ganzglas" && { id: "handlauf", title: "Handlauf" },
    rail && { id: "montage", title: "Montageposition" },
    rail && { id: "form", title: "Geländerform" },
    hatStaebe(cfg) && { id: "staebe", title: "Anzahl Querstäbe" },
    { id: "masse", title: "Maßangaben" },
    { id: "fertig", title: "Ihre Konfiguration" },
  ].filter(Boolean);
}

function setCfg(patch) {
  Object.assign(state.cfg, patch);
  if ("segmente" in patch || "form" in patch || "montage" in patch || "typ" in patch) state.cfg.bestaetigt = false;
  state.fehler = "";
  update();
}
function weiter() {
  const list = schritte(state.cfg);
  const i = list.findIndex((s) => s.id === state.open);
  if (state.open === "masse" && !state.cfg.bestaetigt) { state.confirming = true; renderSteps(); return; }
  state.done.add(state.open);
  state.confirming = false;
  if (i < list.length - 1) state.open = list[i + 1].id;
  renderSteps();
  scrollToStep(state.open);
}
function oeffne(id) {
  const list = schritte(state.cfg);
  const idx = list.findIndex((s) => s.id === id);
  const lastDone = Math.max(-1, ...list.map((s, i) => (state.done.has(s.id) ? i : -1)));
  if (idx <= lastDone + 1) { state.open = id; state.confirming = false; renderSteps(); }
}
function scrollToStep(id) {
  const el = ROOT.querySelector(`[data-step="${id}"]`);
  if (el && el.getBoundingClientRect().top < 0) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/* ----------------------------------------------------------------
   6. Rendering – Grundgerüst
   ---------------------------------------------------------------- */
let els = {};
function shell() {
  const app = ROOT.querySelector("[data-eo24-app]");
  app.setAttribute("aria-busy", "false");
  app.innerHTML = `
    <header class="eo24__head">
      <h2>${esc(S.headline || "Geländer-Konfigurator")}</h2>
      <p class="eo24__intro">${esc(S.intro || "")}</p>
    </header>
    <div class="eo24__grid">
      <div class="eo24__steps" data-steps></div>
      <aside class="eo24__side">
        <div class="eo24__preview">
          <div class="eo24__preview-tabs" role="tablist">
            <button class="eo24__tab" role="tab" data-tab="3d" aria-selected="true">3D-Ansicht</button>
            <button class="eo24__tab" role="tab" data-tab="grundriss" aria-selected="false">Grundriss</button>
          </div>
          <div class="eo24__stage" data-stage-3d><div class="eo24__stage-hint">Ziehen zum Drehen · Scrollen zum Zoomen</div></div>
          <div class="eo24__stage" data-stage-gr hidden></div>
          <div class="eo24__gr-legend" data-gr-legend hidden>
            <span class="l-kante">Außenkante Bodenplatte</span><span class="l-gelaender">Geländerachse</span>
            <span class="l-pfosten" data-legend-post>Pfosten</span><span class="l-wand">fiktive Außenwand</span>
          </div>
        </div>
        <div class="eo24__price" data-price></div>
      </aside>
    </div>
    <div class="eo24__bar" data-bar></div>`;
  els = {
    steps: app.querySelector("[data-steps]"), price: app.querySelector("[data-price]"), bar: app.querySelector("[data-bar]"),
    stage3d: app.querySelector("[data-stage-3d]"), stageGr: app.querySelector("[data-stage-gr]"), grLegend: app.querySelector("[data-gr-legend]"),
    tabs: app.querySelectorAll("[data-tab]"),
  };
  els.tabs.forEach((b) => b.addEventListener("click", () => {
    state.tab = b.dataset.tab;
    els.tabs.forEach((x) => x.setAttribute("aria-selected", String(x === b)));
    els.stage3d.hidden = state.tab !== "3d"; els.stageGr.hidden = state.tab !== "grundriss"; els.grLegend.hidden = state.tab !== "grundriss";
    if (state.tab === "3d") viewer.resize();
  }));
  app.addEventListener("click", onClick);
  app.addEventListener("input", onInput);
  app.addEventListener("change", onChange);
}

function update() { renderSteps(); renderPreview(); renderPreis(); }

/* ---------- Icons ---------- */
const ICON = {
  reling: `<svg viewBox="0 0 76 44"><g stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"><path d="M12 40V6M64 40V6"/><path d="M4 8h68M4 15h68M4 22h68M4 29h68M4 36h68" stroke-width="1.6"/></g></svg>`,
  relingplus: `<svg viewBox="0 0 76 44"><g stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"><path d="M12 40V12M64 40V12"/><path d="M12 12l6-7M64 12l6-7"/><path d="M4 5h68" stroke-width="3"/><path d="M4 18h68M4 25h68M4 32h68M4 39h68" stroke-width="1.6"/></g></svg>`,
  ganzglas: `<svg viewBox="0 0 76 44"><g stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"><rect x="6" y="8" width="64" height="26" fill="currentColor" fill-opacity=".12" stroke-dasharray="3 3" stroke-width="1.4"/><path d="M4 7h68" stroke-width="3"/><rect x="4" y="34" width="68" height="6" fill="currentColor" fill-opacity=".35"/></g></svg>`,
  rund: `<svg viewBox="0 0 76 44"><circle cx="38" cy="22" r="15" fill="none" stroke="currentColor" stroke-width="3"/></svg>`,
  eckig: `<svg viewBox="0 0 76 44"><rect x="23" y="7" width="30" height="30" rx="3" fill="none" stroke="currentColor" stroke-width="3"/></svg>`,
  handlauf: `<svg viewBox="0 0 76 44"><g stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"><path d="M4 16h68" stroke-width="4"/><path d="M18 18v10M58 18v10"/><circle cx="18" cy="32" r="4" stroke-width="2"/><circle cx="58" cy="32" r="4" stroke-width="2"/></g></svg>`,
  aufgeschraubt: `<svg viewBox="0 0 76 44"><g stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round"><rect x="8" y="30" width="60" height="10" fill="currentColor" fill-opacity=".2"/><path d="M38 30V6"/><path d="M28 30h20" stroke-width="3"/></g></svg>`,
  seitlich: `<svg viewBox="0 0 76 44"><g stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round"><rect x="8" y="24" width="44" height="14" fill="currentColor" fill-opacity=".2"/><path d="M60 40V6"/><path d="M52 27h8M52 35h8" stroke-width="3"/></g></svg>`,
  gerade: `<svg viewBox="0 0 76 44"><path d="M8 22h60" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round"/></svg>`,
  l: `<svg viewBox="0 0 76 44"><path d="M8 8v30h60" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  u: `<svg viewBox="0 0 76 44"><path d="M10 6v32h56V6" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  frei: `<svg viewBox="0 0 76 44"><path d="M6 36l14-24 20 10 14-16 16 20" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
};
// Icon für die Stabauswahl: zwei Pfosten, Handlauf und n gleichmäßig verteilte Querstäbe.
const stabIcon = (n) => {
  const linien = stabHoehen(n).map((f) => {
    const y = 40 - f * 34; // 0.14..0.86 -> unten..oben im 44er ViewBox
    return `<path d="M4 ${y.toFixed(1)}h68" stroke-width="1.6"/>`;
  }).join("");
  return `<svg viewBox="0 0 76 44"><g stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"><path d="M12 40V6M64 40V6"/><path d="M4 5h68" stroke-width="3"/>${linien}</g></svg>`;
};

const opt = (group, id, name, desc, icon, pressed, extra = "") =>
  `<button type="button" class="eo24-opt" data-set="${group}" data-val="${esc(id)}" aria-pressed="${pressed}">
    ${icon ? `<span class="eo24-opt__icon" style="color:${pressed ? "var(--eo24-accent)" : "var(--eo24-steel)"}">${icon}</span>` : ""}
    <span class="eo24-opt__name">${esc(name)}</span>
    ${desc ? `<span class="eo24-opt__desc">${desc}</span>` : ""}${extra}
  </button>`;

/* ---------- Schritte ---------- */
function zusammenfassungWert(id, cfg, geo) {
  switch (id) {
    case "typ": return PRODUKTE.find((p) => p.id === cfg.typ)?.name || "";
    case "handlauf": return cfg.handlauf === "eckig" ? "Eckig 40 × 40 mm" : "Rund Ø 42,4 mm";
    case "montage": return cfg.montage === "seitlich" ? "Seitlich an der Bodenplatte" : "Aufgeschraubt auf der Bodenplatte";
    case "form": return FORMEN.find((f) => f.id === cfg.form)?.name || "";
    case "staebe": return stabAnzahl(cfg) + " Querstäbe";
    case "masse": return cfg.typ === "handlauf" ? `Länge ${cfg.segmente[0].l} cm` : cfg.segmente.map((s) => s.l + " cm").join(" · ") + ` → Geländer ${fmtM(geo.gesamt)}`;
    default: return "";
  }
}

function renderSteps() {
  const cfg = state.cfg, geo = berechneGeometrie(cfg);
  const list = schritte(cfg);
  const lastDone = Math.max(-1, ...list.map((s, i) => (state.done.has(s.id) ? i : -1)));
  els.steps.innerHTML = list.map((s, i) => {
    const open = state.open === s.id, done = state.done.has(s.id), reachable = i <= lastDone + 1 && cfg.typ;
    const cls = `eo24-step ${open ? "eo24-step--open" : ""} ${done ? "eo24-step--done" : ""}`;
    const value = !open && (done || reachable) ? zusammenfassungWert(s.id, cfg, geo) : "";
    return `<section class="${cls}" data-step="${s.id}">
      <button type="button" class="eo24-step__head" data-open="${s.id}" ${(!reachable && s.id !== "typ") || open ? "disabled" : ""} aria-expanded="${open}">
        <span class="eo24-step__num">${i + 1}</span>
        <span><span class="eo24-step__title">${esc(s.title)}</span>${value ? `<span class="eo24-step__value">${esc(value)}</span>` : ""}</span>
        ${!open && (done || (reachable && s.id !== "typ")) ? `<span class="eo24-step__edit">Ändern</span>` : ""}
      </button>
      ${open ? `<div class="eo24-step__body">${stepBody(s.id, cfg, geo)}</div>` : ""}
    </section>`;
  }).join("");
}

function stepBody(id, cfg, geo) {
  const foot = (label = "Weiter", disabled = false) => `<div class="eo24-step__foot"><button type="button" class="eo24-btn" data-weiter ${disabled ? "disabled" : ""}>${label}</button></div>`;
  switch (id) {
    case "typ":
      return `<p class="eo24-step__help">Bitte wählen Sie eine Geländerart aus.</p>
        <div class="eo24-opts eo24-opts--wide">${PRODUKTE.map((p) => opt("typ", p.id, p.name, esc(p.desc), ICON[p.id], cfg.typ === p.id)).join("")}</div>
        ${foot("Weiter", !cfg.typ)}`;
    case "handlauf":
      return `<p class="eo24-step__help">Beim Ganzglasgeländer wählen Sie zwischen einem runden und einem eckigen Glaskanten-Handlauf. Er wird auf die Glasoberkante aufgesteckt.</p>
        <div class="eo24-opts">${opt("handlauf", "rund", "Rund Ø 42,4 mm", "Klassisch, angenehm in der Hand", ICON.rund, cfg.handlauf === "rund")}
        ${opt("handlauf", "eckig", "Eckig 40 × 40 mm", "Klare Linie, modern", ICON.eckig, cfg.handlauf === "eckig")}</div>
        ${foot()}`;
    case "montage":
      return `<p class="eo24-step__help">Bitte wählen Sie, ob das Geländer oben auf die Bodenplatte geschraubt oder seitlich an der Balkonkante montiert werden soll.</p>
        <div class="eo24-opts">${opt("montage", "aufgeschraubt", "Aufgeschraubt", "Auf der Bodenplatte, mit Bodenplatte/-profil", ICON.aufgeschraubt, cfg.montage === "aufgeschraubt")}
        ${opt("montage", "seitlich", "Seitlich", "An der Stirnseite der Bodenplatte", ICON.seitlich, cfg.montage === "seitlich")}</div>
        ${cfg.montage === "seitlich" ? `<div class="eo24-note"><b>Hinweis:</b> Bei seitlicher Montage beträgt der Abstand zwischen Anschraubplatte und ${cfg.typ === "ganzglas" ? "Profil" : "Pfostenrohr"} 5 cm. Bei Balkonen mit Dachrinne empfehlen wir die aufgeschraubte Montage.</div>` : ""}
        ${foot()}`;
    case "form":
      return `<p class="eo24-step__help">Welche Grundform hat Ihr Balkon bzw. Ihre Terrasse? Passt keine Standardform, sprechen Sie uns gerne direkt an.</p>
        <div class="eo24-opts">${FORMEN.map((f) => opt("form", f.id, f.name, esc(f.desc), ICON[f.id], cfg.form === f.id)).join("")}</div>
        ${foot()}`;
    case "staebe": {
      const n = stabAnzahl(cfg);
      return `<p class="eo24-step__help">Wie viele waagerechte Querstäbe soll Ihr Geländer haben? Die Stäbe werden gleichmäßig über die Geländerhöhe verteilt; mehr Stäbe bedeuten kleinere Abstände.</p>
        <div class="eo24-opts">${STAB_OPTIONEN.map((k) => opt("staebe", String(k), k + " Querstäbe", `Abstand ca. ${Math.round((0.72 * ((S.gelaenderhoehe || 100))) / (k - 1))} cm`, stabIcon(k), n === k)).join("")}</div>
        ${foot()}`;
    }
    case "masse": return masseBody(cfg, geo, foot);
    case "fertig": return fertigBody(cfg, geo);
  }
  return "";
}

function masseBody(cfg, geo, foot) {
  const hand = cfg.typ === "handlauf";
  const frei = cfg.form === "frei";
  const winkelEdit = frei;
  const segs = cfg.segmente;
  const info = hand
    ? `<div class="eo24-mass-info"><div><small>Handlauflänge</small><b>${fmtM(geo.gesamt)}</b></div><div><small>Wandhalter</small><b>${geo.pfosten.length} Stk</b></div><div><small>Halterabstand</small><b>≈ ${Math.round((geo.gesamt - 30) / Math.max(1, geo.pfosten.length - 1))} cm</b></div></div>`
    : `<div class="eo24-mass-info">
        <div><small>Geländerlänge (berechnet)</small><b>${fmtM(geo.gesamt)}</b></div>
        ${cfg.typ === "ganzglas"
          ? `<div><small>Scheiben (bauseits)</small><b>${geo.segs.reduce((q, x) => q + x.felder, 0)} Stk</b></div><div><small>Scheibenbreite</small><b>≤ ${Math.floor(Math.max(...geo.segs.map((x) => x.feldLaenge)) - 1)} cm</b></div>`
          : `<div><small>Pfosten</small><b>${geo.pfosten.length} Stk</b></div><div><small>Pfostenabstand</small><b>≤ ${Math.round(Math.max(...geo.segs.map((x) => x.feldLaenge)))} cm</b></div>`}
      </div>`;
  const rows = segs.map((s, i) => `<div class="eo24-seg">
      <span class="eo24-seg__idx">${hand ? "L" : "S" + (i + 1)}</span>
      <div class="eo24-field"><label for="eo24-l${i}">${hand ? "Länge Handlauf" : `Länge Seite ${i + 1}`}</label><div class="eo24-input"><input id="eo24-l${i}" type="number" inputmode="numeric" min="30" max="3000" step="1" value="${esc(s.l)}" data-seg="${i}" data-prop="l" aria-invalid="${!(s.l >= 30 && s.l <= 3000)}"><span class="eo24-unit">cm</span></div></div>
      ${hand ? "<div></div>" : i < segs.length - 1
        ? `<div class="eo24-field"><label for="eo24-w${i}">Winkel zu Seite ${i + 2}</label><div class="eo24-input"><input id="eo24-w${i}" type="number" inputmode="numeric" min="-170" max="170" step="1" value="${esc(s.w)}" data-seg="${i}" data-prop="w" ${winkelEdit ? "" : "readonly"}><span class="eo24-unit">°</span></div></div>`
        : `<div class="eo24-field"><label>&nbsp;</label><div class="eo24-input"><span class="eo24-unit" style="position:static">letzte Seite</span></div></div>`}
      ${frei ? `<button type="button" class="eo24-seg__del" data-seg-del="${i}" ${segs.length <= 1 ? "disabled" : ""} aria-label="Seite ${i + 1} entfernen">×</button>` : "<span></span>"}
    </div>`).join("");
  const confirm = state.confirming ? `<div class="eo24-confirm" role="alertdialog" aria-labelledby="eo24-confirm-t">
      <p id="eo24-confirm-t"><b>Bitte prüfen Sie Ihre Maße.</b> Ihr Geländer wird nach der Bestellung automatisch zur Produktion freigegeben; nachträgliche Änderungen sind nicht möglich. Haben Sie die <b>exakten Maße der Außenkante</b> Ihrer Balkonplatte bzw. Terrasse <b>ohne Abzugsmaße</b> angegeben?</p>
      <div class="eo24-confirm__actions"><button type="button" class="eo24-btn" data-bestaetigen>Die angegebenen Maße sind richtig</button><button type="button" class="eo24-btn eo24-btn--warn" data-pruefen>Ich möchte die Maße kontrollieren</button></div>
    </div>` : "";
  return `<p class="eo24-step__help">${hand ? "Bitte geben Sie die gewünschte Gesamtlänge des Handlaufs an. Die Anzahl der Wandhalter (max. 100 cm Abstand) wird automatisch berechnet."
    : `Bitte geben Sie die <b>exakten Maße der Außenkante Ihrer Bodenplatte</b> an – nicht die gewünschte Geländerlänge. Diese wird automatisch berechnet (${cfg.montage === "seitlich" ? "Geländer außen vor der Kante" : cfg.typ === "ganzglas" ? "Profil ca. 4 cm von der Kante eingerückt" : "Pfosten ca. 6 cm von der Kante eingerückt"}).`}
    ${S.aufmassUrl ? ` <a href="${esc(S.aufmassUrl)}" target="_blank" rel="noopener">So nehmen Sie das Aufmaß richtig</a>` : ""}</p>
    ${!hand && !frei ? `<div class="eo24-note eo24-note--info">Bei der ${FORMEN.find((f) => f.id === cfg.form).name} sind die Winkel fest auf 90° (Innenecken) eingestellt. Für andere Winkel kontaktieren Sie uns bitte.</div>` : ""}
    ${rows}
    ${frei ? `<div style="margin-top:10px"><button type="button" class="eo24-btn eo24-btn--ghost eo24-btn--sm" data-seg-add ${segs.length >= 8 ? "disabled" : ""}>+ Seite hinzufügen</button> <span class="muted" style="font-size:12.5px;color:var(--eo24-steel)">Positive Winkel = Innenecke (Geländer knickt zum Gebäude), negative = Außenecke.</span></div>` : ""}
    ${info}
    <div class="eo24-note eo24-note--info">${cfg.typ === "ganzglas" ? "Bodenprofil und Handlauf" : "Rohre, Stäbe und Gurte"} liefern wir in festen Längen (${stdLaengen().join(" / ")} cm). Der Konfigurator wählt die passenden Lieferlängen je Seite; der Zuschnitt auf das genaue Maß erfolgt bauseits. Längere Seiten werden mit Stoßverbindern zusammengesetzt.</div>
    ${geo.ueberstand ? `<div class="eo24-note eo24-note--info">Der Handlauf wird auf Handlaufstützen montiert und überragt die äußeren Pfosten um ca. ${geo.ueberstand} cm je Ende.</div>` : ""}
    ${cfg.bestaetigt ? `<div class="eo24-note eo24-note--ok">Maße bestätigt.</div>` : ""}
    ${confirm}
    ${state.confirming ? "" : foot(cfg.bestaetigt ? "Weiter" : "Weiter – Maße prüfen", !segs.every((s) => s.l >= 30 && s.l <= 3000))}`;
}

function fertigBody(cfg, geo) {
  const bom = stueckliste(cfg, geo);
  bom.forEach((p) => ladePreis(p.key));
  const laden = S.shop && bom.some((p) => !p.geladen);
  // Fehlende Preise blockieren die Bestellung – in BEIDEN Bestellmodi: im Modus "Stückliste"
  // fehlt die Bestellposition, im Modus "Einzelprodukt" wird die Summe aus den Bauteilpreisen
  // gebildet und wäre damit falsch. Lieber keine Bestellung als eine zum falschen Preis.
  const fehlend = S.shop ? bom.filter((p) => p.geladen && !p.ok) : [];
  const preisUnsicher = fehlend.length > 0;
  const sum = gesamtpreis(bom);
  const id = konfigId(cfg);
  const listSteps = schritte(cfg).filter((s) => !["masse", "fertig"].includes(s.id));
  const url = entwurfUrl(cfg);
  const mailBody = `Meine Geländer-Konfiguration ${id}:\n${listSteps.map((s) => `${s.title}: ${zusammenfassungWert(s.id, cfg, geo)}`).join("\n")}\nMaße: ${zusammenfassungWert("masse", cfg, geo)}\nPreis: ${fmtEuro(sum)}\n\nKonfiguration wieder aufrufen:\n${url}`;
  return `<div class="eo24-summary">
    <p class="eo24-step__help">Ihr Geländer ist fertig konfiguriert. Konfigurations-Nr. <span class="eo24-summary__id">${id}</span></p>
    <dl>${listSteps.map((s) => `<dt>${esc(s.title)}</dt><dd>${esc(zusammenfassungWert(s.id, cfg, geo))}</dd>`).join("")}
      <dt>Maße</dt><dd>${esc(zusammenfassungWert("masse", cfg, geo))}</dd>
      <dt>Lieferzeit</dt><dd>${esc(S.lieferzeit || "3 – 7 Werktage")}</dd>
    </dl>
    <div class="eo24-note eo24-note--info">Der Bausatz enthält alle Bauteile in Lieferlängen. Der Zuschnitt auf das exakte Maß sowie die Montage erfolgen bauseits.${cfg.typ === "ganzglas" ? " Glas ist nicht enthalten – siehe Glasliste." : ""}</div>
    ${cfg.typ === "ganzglas" ? glaslisteHtml(cfg, geo) : ""}
    <details ${bom.length <= 6 ? "open" : ""}><summary style="cursor:pointer;font-weight:600">Stückliste (${bom.length} Positionen)</summary>
      <table class="eo24-table"><thead><tr><th>Bauteil</th><th class="num">Menge</th><th class="num">Einzel</th><th class="num">Summe</th></tr></thead><tbody>
      ${bom.map((p) => `<tr><td>${esc(p.name)}${p.hinweis ? `<div class="muted">${esc(p.hinweis)}</div>` : ""}${skuVon(p) ? `<div class="muted">Art.-Nr. ${esc(skuVon(p))}</div>` : ""}${p.geladen && !p.ok && S.shop ? `<div class="muted" style="color:var(--eo24-warn)">${p.laenge ? `Variante ${p.laenge} cm bei „${esc(handleFuer(p.key))}“ nicht gefunden` : `Produkt „${esc(handleFuer(p.key))}“ nicht gefunden`} – kein Preis</div>` : ""}</td>
        <td class="num">${p.menge} Stk</td><td class="num">${fmtEuro(p.einzel)}</td><td class="num">${fmtEuro(p.summe)}</td></tr>`).join("")}
      </tbody><tfoot><tr><td colspan="3">Gesamt inkl. MwSt.</td><td class="num">${fmtEuro(sum)}</td></tr></tfoot></table>
    </details>
    ${cfg.bestaetigt ? "" : `<label class="eo24-checkbox"><input type="checkbox" data-bestaetigen-cb ${cfg.bestaetigt ? "checked" : ""}> <span>Ich habe die <b>exakten Außenkanten-Maße ohne Abzugsmaße</b> angegeben und weiß, dass die Konfiguration nach Bestellung zur Produktion freigegeben wird.</span></label>`}
    ${preisUnsicher ? `<div class="eo24-error"><b>Der Gesamtpreis kann derzeit nicht verbindlich berechnet werden.</b> Für folgende Bauteile ist im Shop kein Preis hinterlegt: <code>${[...new Set(fehlend.map((p) => handleFuer(p.key) + (p.laenge ? ` (${p.laenge} cm)` : "")))].join(", ")}</code>. Bitte legen Sie diese Produkte an oder prüfen Sie die Zuordnung in den Section-Einstellungen. Solange bleibt die Bestellung gesperrt.</div>` : ""}
    ${state.fehler ? `<div class="eo24-error">${esc(state.fehler)}</div>` : ""}
    <div style="margin-top:14px"><button type="button" class="eo24-btn eo24-btn--big" data-cart ${!cfg.bestaetigt || laden || state.sende || preisUnsicher ? "disabled" : ""}>${state.sende ? "Wird in den Warenkorb gelegt …" : laden ? "Preise werden geladen …" : preisUnsicher ? "Preis nicht verfügbar" : `In den Warenkorb – ${fmtEuro(sum)}`}</button></div>
    <h4 style="margin:22px 0 4px;font-size:15px">Entwurf sichern</h4>
    <p class="eo24-step__help" style="margin-top:0">Lieber später bestellen? Senden Sie sich die Konfiguration zu – über den Link lässt sie sich jederzeit wieder öffnen.</p>
    <div class="eo24-save">
      <a class="eo24-btn eo24-btn--ghost eo24-btn--sm" href="mailto:?subject=${encodeURIComponent("Geländer-Konfiguration " + id)}&body=${encodeURIComponent(mailBody)}">Per E-Mail</a>
      <a class="eo24-btn eo24-btn--ghost eo24-btn--sm" href="https://wa.me/${S.whatsapp ? esc(S.whatsapp) : ""}?text=${encodeURIComponent(mailBody)}" target="_blank" rel="noopener">Per WhatsApp</a>
      <button type="button" class="eo24-btn eo24-btn--ghost eo24-btn--sm" data-copy>Link kopieren</button>
    </div>
  </div>`;
}

function glaslisteHtml(cfg, geo) {
  const gl = glasliste(cfg, geo);
  return `<details open><summary style="cursor:pointer;font-weight:600">Glasliste für bauseitige Beschaffung (${gl.anzahl} Scheibe${gl.anzahl > 1 ? "n" : ""})</summary>
    <table class="eo24-table"><thead><tr><th>Seite</th><th class="num">Anzahl</th><th class="num">Breite</th><th class="num">Höhe</th></tr></thead><tbody>
    ${gl.list.map((g) => `<tr><td>Seite ${g.seite}</td><td class="num">${g.anzahl}</td><td class="num">≈ ${g.breite} cm</td><td class="num">≈ ${g.hoehe} cm</td></tr>`).join("")}
    </tbody></table>
    <p class="muted" style="font-size:12.5px;color:var(--eo24-steel);margin:8px 0 0">Richtmaße für Ihre Glasanfrage: VSG aus ESG, für 0,5 kN Holmlast typisch 17,52 mm (2 × 8 mm), Kanten poliert, 10 cm Profileinstand, 1 cm Fuge zwischen den Scheiben. Verbindliche Maße bitte erst nach Montage der Bodenprofile nehmen und mit Ihrem Glaslieferanten abstimmen.</p>
  </details>`;
}

/* ---------- Preisbox ---------- */
function renderPreis() {
  const cfg = state.cfg;
  if (!cfg.typ) {
    els.price.innerHTML = `<span class="eo24__price-label">Ihr Preis</span><span class="eo24__price-sum">–</span><span class="eo24__price-note">Wählen Sie zuerst eine Geländerart.</span>`;
    els.bar.innerHTML = `<span><small>Ihr Preis</small><b>–</b></span>`;
    return;
  }
  const geo = berechneGeometrie(cfg), bom = stueckliste(cfg, geo);
  bom.forEach((p) => ladePreis(p.key));
  const sum = gesamtpreis(bom);
  const richt = S.shop && bom.some((p) => !p.geladen || !p.ok);
  const meta = cfg.typ === "handlauf"
    ? `<span>Länge <b>${fmtM(geo.gesamt)}</b></span><span>Wandhalter <b>${geo.pfosten.length}</b></span>`
    : `<span>Geländerlänge <b>${fmtM(geo.gesamt)}</b></span>${cfg.typ === "ganzglas" ? `<span>Scheiben bauseits <b>${geo.segs.reduce((q, x) => q + x.felder, 0)}</b></span>` : `<span>Pfosten <b>${geo.pfosten.length}</b></span>`}${geo.ecken ? `<span>Ecken <b>${geo.ecken}</b></span>` : ""}`;
  els.price.innerHTML = `<span class="eo24__price-label">Ihr Preis</span><span class="eo24__price-sum">${fmtEuro(sum)}<small>inkl. MwSt.</small></span>
    <span class="eo24__price-meta">${meta}</span>
    <span class="eo24__price-note">${richt ? "Richtpreis – einzelne Produktpreise werden noch geladen." : cfg.typ === "ganzglas" ? "Bausatz ohne Glas, Zuschnitt und Glas bauseits." : "Bausatz in Lieferlängen, Zuschnitt bauseits."}</span>`;
  els.bar.innerHTML = `<span><small>${esc(PRODUKTE.find((p) => p.id === cfg.typ)?.name || "")} · ${fmtM(geo.gesamt)}</small><b>${fmtEuro(sum)}</b></span><button type="button" class="eo24-btn eo24-btn--sm" data-jump-fertig ${state.done.has("fertig") || state.open === "fertig" ? "" : ""}>${state.open === "fertig" ? "Zum Warenkorb-Button" : "Zur Zusammenfassung"}</button>`;
}

/* ---------- Events ---------- */
function onClick(e) {
  const b = e.target.closest("button, a");
  if (!b || !ROOT.contains(b)) return;
  if (b.dataset.set) { setCfgVal(b.dataset.set, b.dataset.val); return; }
  if (b.hasAttribute("data-weiter")) { weiter(); return; }
  if (b.dataset.open) { oeffne(b.dataset.open); return; }
  if (b.hasAttribute("data-bestaetigen")) { state.cfg.bestaetigt = true; state.confirming = false; weiter(); return; }
  if (b.hasAttribute("data-pruefen")) { state.confirming = false; renderSteps(); return; }
  if (b.hasAttribute("data-seg-add")) { const s = state.cfg.segmente.slice(); s[s.length - 1] = { ...s[s.length - 1], w: s[s.length - 1].w || 90 }; s.push({ l: 150, w: 90 }); setCfg({ segmente: s }); return; }
  if (b.dataset.segDel !== undefined) { const s = state.cfg.segmente.filter((_, i) => i !== Number(b.dataset.segDel)); setCfg({ segmente: s }); return; }
  if (b.hasAttribute("data-cart")) { inDenWarenkorb(); return; }
  if (b.hasAttribute("data-copy")) { navigator.clipboard?.writeText(entwurfUrl(state.cfg)).then(() => { b.textContent = "Link kopiert"; setTimeout(() => (b.textContent = "Link kopieren"), 2000); }); return; }
  if (b.hasAttribute("data-jump-fertig")) {
    const ids = schritte(state.cfg).map((s) => s.id);
    if (state.cfg.bestaetigt) { state.done = new Set(ids.filter((x) => x !== "fertig")); state.open = "fertig"; state.confirming = false; }
    else { state.done = new Set(ids.slice(0, ids.indexOf("masse"))); state.open = "masse"; state.confirming = true; }
    renderSteps();
    ROOT.querySelector(`[data-step="${state.open}"]`)?.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
}
function setCfgVal(group, val) {
  const patch = { [group]: val };
  if (group === "staebe") patch.staebe = clamp(Number(val) || 5, 4, 7); // kommt als Text aus dem Button
  if (group === "form") {
    const f = FORMEN.find((x) => x.id === val);
    const cur = state.cfg.segmente;
    patch.segmente = f.segmente.map((l, i) => ({ l: cur[i]?.l ?? l, w: val === "frei" ? (cur[i]?.w ?? 90) : 90 }));
  }
  if (group === "typ") {
    if (val === "handlauf") patch.segmente = [{ l: state.cfg.segmente[0]?.l || 300, w: 0 }];
    else if (state.cfg.typ === "handlauf") { patch.form = "gerade"; patch.segmente = [{ l: state.cfg.segmente[0]?.l || 300, w: 90 }]; }
    // Schritte, die es für die neue Art nicht mehr gibt, aus "erledigt" entfernen
    const ids = new Set(schritte({ ...state.cfg, ...patch }).map((s) => s.id));
    state.done = new Set([...state.done].filter((d) => ids.has(d)));
  }
  setCfg(patch);
}
function onInput(e) {
  const inp = e.target;
  if (inp.dataset.seg === undefined) return;
  const i = Number(inp.dataset.seg), prop = inp.dataset.prop, v = Number(inp.value);
  if (!Number.isFinite(v)) return;
  state.cfg.segmente[i][prop] = v;
  state.cfg.bestaetigt = false;
  inp.setAttribute("aria-invalid", String(prop === "l" ? !(v >= 30 && v <= 3000) : !(v >= -170 && v <= 170)));
  renderPreview(); renderPreis();
  // Info-Kacheln live aktualisieren ohne Fokusverlust
  const geo = berechneGeometrie(state.cfg);
  const body = ROOT.querySelector('[data-step="masse"] .eo24-mass-info');
  if (body) { const tmp = document.createElement("div"); tmp.innerHTML = masseBody(state.cfg, geo, () => ""); body.replaceWith(tmp.querySelector(".eo24-mass-info")); }
}
function onChange(e) {
  const inp = e.target;
  if (inp.dataset.seg !== undefined) {
    const i = Number(inp.dataset.seg), prop = inp.dataset.prop;
    const v = prop === "l" ? clamp(Math.round(Number(inp.value) || 30), 30, 3000) : clamp(Math.round(Number(inp.value) || 0), -170, 170);
    state.cfg.segmente[i][prop] = v; state.cfg.bestaetigt = false; state.confirming = false;
    update(); return;
  }
  if (inp.hasAttribute("data-bestaetigen-cb")) { state.cfg.bestaetigt = inp.checked; renderSteps(); }
}

/* ----------------------------------------------------------------
   7. Vorschau: Grundriss (SVG) + 3D (Three.js, lazy)
   ---------------------------------------------------------------- */
function renderPreview() {
  const cfg = state.cfg;
  const geo = cfg.typ ? berechneGeometrie(cfg) : berechneGeometrie({ ...cfg, typ: "reling" });
  els.stageGr.innerHTML = grundrissSvg(cfg, geo);
  const legendPost = els.grLegend.querySelector("[data-legend-post]");
  if (legendPost) legendPost.textContent = cfg.typ === "handlauf" ? "Wandhalter" : cfg.typ === "ganzglas" ? "Scheibenstöße" : "Pfosten";
  viewer.build(cfg, geo);
}

function grundrissSvg(cfg, geo) {
  const hand = cfg.typ === "handlauf";
  const innen = hand ? offsetPolyline(geo.kante, 7.5) : offsetPolyline(geo.kante, geo.tiefe);
  const wand = hand ? offsetPolyline(geo.kante, 27.5) : offsetPolyline(geo.kante, geo.tiefe + 24);
  const all = [...geo.kante, ...wand, ...geo.linie];
  const minX = Math.min(...all.map((p) => p.x)) - 70, maxX = Math.max(...all.map((p) => p.x)) + 70;
  const minY = Math.min(...all.map((p) => p.y)) - 70, maxY = Math.max(...all.map((p) => p.y)) + 40;
  const W = 640, H = 380, sc = Math.min(W / (maxX - minX), H / (maxY - minY));
  const X = (x) => ((x - minX) * sc + (W - (maxX - minX) * sc) / 2).toFixed(1);
  const Y = (y) => (H - ((y - minY) * sc + (H - (maxY - minY) * sc) / 2)).toFixed(1);
  const path = (pts) => pts.map((p, i) => `${i ? "L" : "M"}${X(p.x)} ${Y(p.y)}`).join(" ");
  const poly = (a, b) => path([...a, ...b.slice().reverse()]) + " Z";
  let s = `<svg class="eo24__grundriss" viewBox="0 0 ${W} ${H}" role="img" aria-label="Grundriss der Konfiguration">
    <defs><pattern id="eo24hatch" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="6" height="6" fill="#e3e7ea"/><line x1="0" y1="0" x2="0" y2="6" stroke="#9aa3ab" stroke-width="1.6"/></pattern></defs>`;
  s += `<path d="${poly(innen, wand)}" fill="url(#eo24hatch)" stroke="#9aa3ab" stroke-width="1"/>`;
  if (!hand) s += `<path d="${poly(geo.kante, innen)}" fill="#f0f2f4" stroke="none"/>`;
  s += `<path d="${path(geo.kante)}" fill="none" stroke="${hand ? "#1f4f8f" : "#1a1f24"}" stroke-width="${hand ? 5 : 3}" stroke-linejoin="round" stroke-linecap="round"/>`;
  if (!hand) s += `<path d="${path(geo.linieHL || geo.linie)}" fill="none" stroke="#1f4f8f" stroke-width="2" stroke-dasharray="${cfg.typ === "ganzglas" ? "0" : "6 4"}" stroke-linejoin="round"/>`;
  // Pfosten / Wandhalter / Scheibenstöße
  if (cfg.typ === "ganzglas") geo.segs.forEach((sg) => sg.pts.forEach((p) => { s += `<line x1="${X(p.x - sg.nx * 6)}" y1="${Y(p.y - sg.ny * 6)}" x2="${X(p.x + sg.nx * 6)}" y2="${Y(p.y + sg.ny * 6)}" stroke="#1f4f8f" stroke-width="2"/>`; }));
  else geo.pfosten.forEach((p) => { s += `<circle cx="${X(p.x)}" cy="${Y(p.y)}" r="${hand ? 4 : 5}" fill="#1f4f8f" stroke="#fff" stroke-width="1.5"/>`; });
  // Bemaßung außen (rechts der Laufrichtung)
  for (let i = 0; i < geo.kante.length - 1; i++) {
    const a = geo.kante[i], b = geo.kante[i + 1], len = dist(a, b);
    const dx = (b.x - a.x) / len, dy = (b.y - a.y) / len, nx = dy, ny = -dx; // nach außen
    const off = hand ? -20 : 30;
    const a2 = { x: a.x + nx * off, y: a.y + ny * off }, b2 = { x: b.x + nx * off, y: b.y + ny * off };
    const m = { x: (a2.x + b2.x) / 2 + nx * 11, y: (a2.y + b2.y) / 2 + ny * 11 };
    s += `<g stroke="#1f4f8f" stroke-width="1"><line x1="${X(a2.x)}" y1="${Y(a2.y)}" x2="${X(b2.x)}" y2="${Y(b2.y)}"/><line x1="${X(a.x + nx * (off - 6))}" y1="${Y(a.y + ny * (off - 6))}" x2="${X(a.x + nx * (off + 6))}" y2="${Y(a.y + ny * (off + 6))}"/><line x1="${X(b.x + nx * (off - 6))}" y1="${Y(b.y + ny * (off - 6))}" x2="${X(b.x + nx * (off + 6))}" y2="${Y(b.y + ny * (off + 6))}"/></g>`;
    s += `<text class="eo24-gr-dim" x="${X(m.x)}" y="${Y(m.y)}" text-anchor="middle" dominant-baseline="middle">${Math.round(len)} cm</text>`;
    if (!hand && i < geo.kante.length - 2) { const w = cfg.segmente[i]?.w ?? 90; s += `<text x="${X(b.x - nx * 18 - dx * 14)}" y="${Y(b.y - ny * 18 - dy * 14)}" text-anchor="middle" dominant-baseline="middle" fill="#66717b">${w}°</text>`; }
  }
  const lab = wand[Math.floor(wand.length / 2)];
  s += `<text class="eo24-gr-legend" x="${X(hand ? geo.kante[0].x : lab.x)}" y="${Number(Y(lab.y)) - 6}" text-anchor="${hand ? "start" : "middle"}">${hand ? "Wand" : "fiktive Außenwand"}</text>`;
  if (!hand) s += `<text class="eo24-gr-legend" x="${X(geo.kante[0].x)}" y="${Number(Y(geo.kante[0].y)) + 42}" text-anchor="start">Geländer ${fmtM(geo.gesamt)} · ${cfg.typ === "ganzglas" ? geo.segs.reduce((q, x) => q + x.felder, 0) + " Scheiben (bauseits)" : geo.pfosten.length + " Pfosten"}</text>`;
  return s + `</svg>`;
}

/* ---------- 3D-Viewer ---------- */
const viewer = (() => {
  let THREE = null, renderer, scene, camera, group, envTex, loading = null, pending = null;
  let theta = -0.55, phi = 1.12, radius = 6, target = { x: 0, y: 0.5, z: 0 }, auto = !matchMedia("(prefers-reduced-motion: reduce)").matches, dirty = true;
  const MAT = {};
  let stuetzeGlb = null, stuetzeLoading = null; // 60722-240 (Handlaufstütze)
  let pfostenGlb = null, pfostenLoading = null; // 40511-240 (Pfosten mit Bodenplatte, 5 Anschraubpunkte), Originallänge 880mm
  let halterGlb = null, halterLoading = null; // 50400-240A (Querstabhalter), 22 x 22 x 42,4 mm
  let kappeGlb = null, kappeLoading = null;   // 50310-240 (Handlauf-Endkappe), Ø 42,4 x 15 mm
  let wandhalterGlb = null, wandhalterLoading = null; // 50213-V4A-42 (Wandhalter)
  const pfostenSeitlichGlb = {};             // 40532-240, je Gewindeanzahl eine Variante (4/5/6/7)
  let plusHalterGlb = null, plusHalterLoading = null; // 50372-240 (Handlaufhalter Reling-PLUS)
  let eckHalterGlb = null, eckHalterLoading = null;   // 60201-240E (Eckhalter 90°, fertig geknickt)
  // Eckpfosten bei Aufbodenmontage: Querstabhalter 90° (Außen-/Innenecke) und Handlaufstütze 90°
  let eckStabAeGlb = null, eckStabIeGlb = null, eckStuetzeGlb = null;

  async function load() {
    if (THREE) return true;
    if (loading) return loading;
    loading = import(S.threeUrl || "https://cdn.jsdelivr.net/npm/three@0.165.0/+esm").then((m) => { THREE = m; init(); return true; }).catch((err) => {
      els.stage3d.innerHTML = `<div class="eo24-error" style="margin:16px">3D-Vorschau konnte nicht geladen werden (${esc(err.message)}). Der Grundriss ist weiterhin verfügbar.</div>`;
      return false;
    });
    return loading;
  }
  // Lädt ein reales Bauteil (STEP → glTF) einmalig und cacht das Ergebnis in cacheKey (Objekt mit .glb/.loading
  // Feldern). Bei Fehler bleibt .glb null und der Aufrufer fällt automatisch auf die parametrische Näherung zurück.
  // Shopify verändert Binärdateien im Theme-Ordner "assets" – GLB-Dateien sind danach unbrauchbar
  // ("Offset is outside the bounds of the DataView"). Die Modelle gehören deshalb unter
  // Inhalte → Dateien. Shopify legt sie dort unter einer je Datei eigenen Kennung ab
  // (/3d/models/<kennung>/name.glb); eine gemeinsame Basis-Adresse gibt es also nicht.
  // Darum wird eine Liste der Adressen hinterlegt und über den Dateinamen zugeordnet.
  let modellListe = null;
  function modellUrl(assetUrl) {
    if (!assetUrl) return assetUrl;
    if (!modellListe) {
      modellListe = {};
      String(S.modelleUrls || "").split(/[\r\n,;\s]+/).forEach((u) => {
        const t = u.trim();
        if (!/^https?:\/\//i.test(t) && !t.startsWith("//")) return;
        const datei = t.split("?")[0].split("/").pop().toLowerCase();
        if (datei.endsWith(".glb")) modellListe[datei] = t;
      });
    }
    const datei = String(assetUrl).split("?")[0].split("/").pop().toLowerCase();
    return modellListe[datei] || assetUrl;
  }
  function ladeBauteil(cache, url, dataB64) {
    url = modellUrl(url);
    if (cache.glb || (!url && !dataB64)) return Promise.resolve(cache.glb);
    if (cache.loading) return cache.loading;
    cache.loading = (async () => {
      try {
        const { GLTFLoader } = await import(S.gltfLoaderUrl || "https://cdn.jsdelivr.net/npm/three@0.165.0/examples/jsm/loaders/GLTFLoader.js/+esm");
        const loader = new GLTFLoader();
        let gltf;
        if (dataB64) { // Demo/Offline: Bauteil als Base64 eingebettet, kein externer Abruf nötig
          const bin = atob(dataB64), buf = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
          gltf = await new Promise((res, rej) => loader.parse(buf.buffer, "", res, rej));
        } else {
          gltf = await loader.loadAsync(url);
        }
        gltf.scene.traverse((o) => {
          if (!o.isMesh) return;
          // Manche Modelle enthalten nur Punkte, keine Normalen – dann rechnet Three.js mit einer
          // Null-Normalen und das Bauteil erscheint komplett schwarz. Deshalb hier nachrechnen.
          if (o.geometry && !o.geometry.getAttribute("normal")) o.geometry.computeVertexNormals();
          o.material = MAT.steel; o.castShadow = true; o.receiveShadow = true;
        });
        cache.glb = gltf.scene;
      } catch (err) {
        // Fehler nicht verschlucken: Ohne Hinweis sieht man nur die vereinfachte Ersatzdarstellung
        // und rätselt, warum das Original-Bauteil fehlt.
        console.warn("EO24: 3D-Bauteil konnte nicht geladen werden.", { url: url || "(eingebettet)", fehler: err && err.message ? err.message : err });
        cache.glb = null;
      }
      return cache.glb;
    })();
    return cache.loading;
  }
  const stuetzeCache = {}, pfostenCache = {}, halterCache = {}, kappeCache = {}, wandhalterCache = {};
  const pfostenSeitlichCache = { 4: {}, 5: {}, 6: {}, 7: {} };
  const plusHalterCache = {}, eckHalterCache = {};
  const eckStabAeCache = {}, eckStabIeCache = {}, eckStuetzeCache = {};
  async function ladeBauteile() {
    stuetzeGlb = await ladeBauteil(stuetzeCache, S.handlaufstuetzeUrl, S.handlaufstuetzeData);
    pfostenGlb = await ladeBauteil(pfostenCache, S.pfostenUrl, S.pfostenData);
    halterGlb = await ladeBauteil(halterCache, S.querstabhalterUrl, S.querstabhalterData);
    kappeGlb = await ladeBauteil(kappeCache, S.endkappeUrl, S.endkappeData);
    wandhalterGlb = await ladeBauteil(wandhalterCache, S.wandhalterUrl, S.wandhalterData);
    plusHalterGlb = await ladeBauteil(plusHalterCache, S.plusHalterUrl, S.plusHalterData);
    eckHalterGlb = await ladeBauteil(eckHalterCache, S.eckHalterUrl, S.eckHalterData);
    // Eckbauteile nur laden, wenn die Konfiguration überhaupt Ecken hat
    if ((state.cfg.segmente || []).length > 1) {
      eckStabAeGlb = await ladeBauteil(eckStabAeCache, S.eckStabAeUrl, S.eckStabAeData);
      eckStabIeGlb = await ladeBauteil(eckStabIeCache, S.eckStabIeUrl, S.eckStabIeData);
      eckStuetzeGlb = await ladeBauteil(eckStuetzeCache, S.eckStuetzeUrl, S.eckStuetzeData);
    }
    // Seitliche Pfosten: nur die tatsächlich gebrauchte Variante laden, nicht alle vier.
    const nG = stabAnzahl(state.cfg);
    if (nG && !pfostenSeitlichGlb[nG]) {
      pfostenSeitlichGlb[nG] = await ladeBauteil(
        pfostenSeitlichCache[nG], (S.pfostenSeitlichUrl || {})[nG], (S.pfostenSeitlichData || {})[nG]);
    }
  }
  // Platziert eine Kopie der Original-Handlaufstütze am Pfosten p; Modell-Ursprung = Kontaktpunkt
  // Handlauf-Unterseite. Grundausrichtung per Kalibrierungs-Tool bestätigt
  // (demo/kalibrierung-pfosten-stuetze.html); die zweite Rotation dreht die Stütze anschließend
  // in die Handlaufrichtung am jeweiligen Pfosten.
  function stuetzeInstanz(p, handlaufY) {
    const inst = stuetzeGlb.clone(true);
    inst.quaternion.setFromEuler(new THREE.Euler(1.57080, 0.00000, 0.00000, "XYZ"));
    inst.quaternion.premultiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.atan2(-p.nx, p.ny)));
    inst.position.copy(V(p, handlaufY));
    group.add(inst);
  }
  // Platziert eine Kopie des Original-Pfostens (Bodenplatte + Rohr, Originallänge 880mm) am Punkt p.
  // Modell-Ursprung = Bodenplatte (unteres Ende); wird auf die eingestellte Geländerhöhe
  // gestreckt/gestaucht (bei Standardhöhe ~1% Abweichung von der Originallänge). Ausrichtung
  // per Kalibrierungs-Tool bestätigt (demo/kalibrierung-pfosten-stuetze.html): zusätzlich 90° um die
  // Hochachse, damit die Anschraubbohrungen zur Gebäudeseite zeigen (dorthin, wo die Querstäbe laufen).
  function pfostenInstanz(p, postTopY) {
    const inst = pfostenGlb.clone(true);
    inst.quaternion.setFromEuler(new THREE.Euler(1.57080, 0.00000, 0.00000, "XYZ"));
    inst.quaternion.premultiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), wandWinkel(p) + Math.PI / 2));
    inst.scale.z = postTopY / 0.88;
    inst.position.copy(V(p, 0));
    group.add(inst);
  }
  // Platziert den Original-Pfosten für seitliche Montage (40532-240) am Punkt p.
  // Aus dem Modell ausgemessen: Länge 1190 mm entlang der lokalen Z-Achse, Z = 0 ist das untere Ende
  // (lokal -Z zeigt also nach oben). Die Anschraubplatte liegt bei lokal -Y (zur Balkonkante), die
  // Gewinde für die Querstabhalter bei lokal +Y (zur Gebäudeseite). Die Rohrachse liegt 2,8 mm
  // neben dem Ursprung, das wird beim Setzen ausgeglichen.
  const PFOSTEN_SEITLICH_LAENGE = 1.19;
  const PFOSTEN_SEITLICH_ACHSVERSATZ = 0.0028;
  function pfostenSeitlichInstanz(glb, p, postTopY) {
    const inst = glb.clone(true);
    // lokal -Z nach oben drehen. Anschließend wird lokal -Y (die Anschraubplatte) zur Bodenplatte
    // hin ausgerichtet, also in +Normalenrichtung – der Pfosten hängt ja an deren Stirnseite.
    // Dadurch zeigen die Gewinde (lokal +Y) zwangsläufig nach außen: Platte und Gewinde liegen sich
    // am Rohr gegenüber. Die Querstäbe laufen bei seitlicher Montage deshalb auf der Außenseite.
    inst.quaternion.setFromAxisAngle(new THREE.Vector3(1, 0, 0), Math.PI / 2);
    inst.quaternion.premultiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), wandWinkel(p) + Math.PI));
    const v = -PFOSTEN_SEITLICH_ACHSVERSATZ * 100; // cm, Ursprung liegt neben der Rohrachse (mitgedreht)
    inst.position.copy(V({ x: p.x + (p.nx || 0) * v, y: p.y + (p.ny ?? 1) * v }, postTopY - PFOSTEN_SEITLICH_LAENGE));
    group.add(inst);
  }
  // Eckhalter 60201-240E am 90°-Eckpfosten (seitliche Montage). Das Bauteil ist bereits auf die im
  // Kalibrierungs-Tool ermittelten Winkel geknickt (Platten 270°, Schellen -145°).
  // Ermittelte Lage im Tool: Grunddrehung (-90°, 0°, 90°), Ursprung 208,6 / -150 / 64,6 mm vom
  // Pfosten aus – gemessen in einem System, dessen Winkelhalbierende bei 45° liegt.
  // Das Bauteil ist auf Plattenwinkel 270° und Schellenwinkel 225° geknickt; bei 225° stehen die
  // Schellen symmetrisch zur Ecke (das Modell wird dadurch 230,7 × 230,7 mm, also gleichseitig). Beim Einsetzen
  // wird alles um die Hochachse gedreht, bis diese Winkelhalbierende zur echten Eckrichtung passt.
  // Die Höhe bezieht sich auf die OBERKANTE DER BODENPLATTE (y = 0), nicht auf den Pfostenkopf –
  // der Halter sitzt unten an der Stirnseite, dort wo bei den übrigen Pfosten die Anschraubplatte ist.
  // Als Zahlen, nicht als THREE-Vektor: Diese Zeile läuft, bevor Three.js geladen ist.
  const ECK_VERSATZ = [0.2086, -0.150, 0.0646];
  function eckHalterInstanz(p) {
    const inst = eckHalterGlb.clone(true);
    // Winkelhalbierende des Pfostens in Weltkoordinaten (V bildet Grundriss-y auf -z ab)
    const bx = p.bx ?? 0, bz = -(p.by ?? 1);
    const phi = Math.atan2(bx, bz) - Math.PI / 4; // im Tool lag sie bei 45°
    const dreh = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), phi);
    inst.quaternion.setFromEuler(new THREE.Euler(-Math.PI / 2, 0, Math.PI / 2, "XYZ"));
    inst.quaternion.premultiply(dreh);
    inst.position.copy(V(p, 0)).add(new THREE.Vector3(...ECK_VERSATZ).applyQuaternion(dreh));
    group.add(inst);
  }
  // Reling-PLUS: Handlaufhalter 50372-240. Lage im Kalibrierungs-Tool ermittelt; die Höhe ist daraus
  // rechnerisch verfeinert, sodass der Handlauf spielfrei aufliegt (Auflagebreite 63,8 mm).
  const PLUS_HALTER_TIEFE = 1.5;      // cm, Versatz zur Gebäudeseite
  const PLUS_HALTER_ABSENKUNG = 0.0294; // m, unter der Pfostenoberkante
  function plusHalterInstanz(p, postTopY) {
    const inst = plusHalterGlb.clone(true);
    inst.quaternion.setFromEuler(new THREE.Euler(-Math.PI / 2, 0, -Math.PI, "XYZ"));
    inst.quaternion.premultiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), wandWinkel(p)));
    inst.position.copy(V({ x: p.x + (p.nx || 0) * PLUS_HALTER_TIEFE, y: p.y + (p.ny ?? 1) * PLUS_HALTER_TIEFE },
      postTopY - PLUS_HALTER_ABSENKUNG));
    group.add(inst);
  }
  // Drehwinkel um die Hochachse, der die "Gebäudeseite" des Kalibrierungs-Tools (dort +Z) auf die
  // tatsächliche Normalenrichtung dieses Pfostens abbildet. V(p,h) bildet die Grundriss-Normale
  // (nx,ny) auf die Weltrichtung (nx, 0, -ny) ab; die positive Normale zeigt zur Gebäudeseite,
  // weil die Geländerachse um +d von der Außenkante nach innen versetzt wird.
  function wandWinkel(p) {
    return Math.atan2(p.nx || 0, -(p.ny ?? 1));
  }
  // Steckt eine Original-Endkappe (50310-240) in ein Handlaufrohr-Ende.
  // Aufbau des Bauteils entlang seiner lokalen Z-Achse (aus dem GLB ausgemessen):
  //   Z =  0 .. -6,5 mm  Steckzapfen Ø 38,8 mm  (steckt im Rohr, Innenmaß Ø 38,4 mm)
  //   Z = -7,5 .. -10,5  Bund Ø 42,4 mm         (bündig mit dem Rohr)
  //   Z = -12 .. -15     gewölbter Abschluss    (sichtbar außen)
  // Der Übergang Zapfen→Bund bei Z = -6,5 mm liegt also genau auf der Rohr-Stirnfläche.
  // Das Teil ist exakt rotationssymmetrisch (geprüft), deshalb zählt nur die Achsrichtung –
  // eine Verdrehung um die eigene Achse ist ohne Wirkung und muss nicht kalibriert werden.
  const KAPPE_BUND = 0.0065; // m, Abstand Ursprung → Rohr-Stirnfläche
  function kappeInstanz(endPunkt, innenRichtung) {
    const inst = kappeGlb.clone(true);
    // Lokale +Z-Achse zeigt vom Abschluss zum Zapfen, also in das Rohr hinein.
    inst.quaternion.setFromUnitVectors(new THREE.Vector3(0, 0, 1), innenRichtung.clone().normalize());
    inst.position.copy(endPunkt).addScaledVector(innenRichtung.clone().normalize(), KAPPE_BUND);
    group.add(inst);
  }
  // Original-Wandhalter 50213-V4A-42. Ausrichtung im Kalibrierungs-Tool ermittelt (Drehung 90° um X);
  // die beiden Abstände sind daraus rechnerisch bestimmt, indem das Bauteil so weit abgesenkt wurde,
  // bis es das Rohr (Ø 42,4 mm) genau berührt:
  //   - Auflagefläche mittig unter der Rohrachse  → Ausladung Wandfläche→Rohrmitte = 75,0 mm
  //   - Absenkung des Bauteilursprungs unter die Rohrachse = 72,2 mm
  // Damit liegt das Rohr auf 70 mm Breite auf. (Zum Vergleich: mit einer zusätzlichen Verdrehung um
  // die Rohrachse berührte nur noch eine Kante auf ca. 4 mm – deshalb bleibt es bei 0°.)
  const WANDHALTER_AUSLADUNG = 0.075;  // Wandfläche → Rohrmitte
  const WANDHALTER_ABSENKUNG = 0.0722; // Rohrmitte → Bauteilursprung
  function wandhalterInstanz(p, hoehe) {
    const inst = wandhalterGlb.clone(true);
    inst.quaternion.setFromAxisAngle(new THREE.Vector3(1, 0, 0), Math.PI / 2);
    // V() bildet Grundriss-y auf Welt-(-z) ab; y = Ausladung in cm rückt den Halter zur Wand.
    inst.position.copy(V({ x: p.x, y: WANDHALTER_AUSLADUNG * 100 }, hoehe - WANDHALTER_ABSENKUNG));
    group.add(inst);
  }
  // Setzt an beide Enden einer Handlauf-Polylinie je eine Endkappe.
  function endkappen(pts, hoehe) {
    if (!kappeGlb || pts.length < 2) return;
    const n = pts.length;
    const a = V(pts[0], hoehe), a2 = V(pts[1], hoehe);
    const b = V(pts[n - 1], hoehe), b2 = V(pts[n - 2], hoehe);
    kappeInstanz(a, new THREE.Vector3().subVectors(a2, a)); // am Anfang zeigt "innen" zum zweiten Punkt
    kappeInstanz(b, new THREE.Vector3().subVectors(b2, b)); // am Ende zum vorletzten Punkt
  }
  // um "halterAbstand" von der Pfostenachse Richtung Gebäudeseite, dort wo der Querstab vorbeiläuft.
  // Position und Drehung per Kalibrierungs-Tool bestätigt.
  // halterAbstand ist vorzeichenbehaftet: positiv zur Gebäudeseite (aufgeschraubte Montage),
  // negativ nach außen (seitliche Montage, dort zeigen die Gewinde nach außen). Der Halter wird
  // entsprechend mitgedreht, damit er zum Pfosten hin ausgerichtet bleibt.
  // Querstabhalter 90° am Eckpfosten (50400-240A-AE / -IE), aus den STEP-Dateien ausgemessen:
  //   lokal +Y = Pfostenachse (nach oben), Y = 0 = Höhe der Querstabachsen
  //   lokal +Z = vom Pfosten weg, Z = 0 = Anlage am Pfostenrohr (Pfostenachse bei Z = -21,2 mm)
  //   Die beiden Bohrungen Ø 12,2 mm liegen unter ±45° und schneiden sich auf der Z-Achse bei
  //   37,8 mm, also 59,0 mm von der Pfostenachse. Das entspricht Querstäben 41,7 mm neben der Achse.
  //   AE: Stäbe laufen vom Schnittpunkt nach außen weg (Stäbe auf der Innenseite des Knicks)
  //   IE: Stäbe laufen vom Schnittpunkt Richtung Pfosten (Stäbe auf der Außenseite des Knicks)
  // Die Querstäbe liegen im Konfigurator 43 mm neben der Achse; der Halter wird deshalb um 1,8 mm
  // weiter hinausgesetzt, damit die Bohrungen genau auf den Stäben sitzen.
  const ECK_STAB_ANLAGE = 0.0212 + 0.0018;
  function eckStabHalterInstanz(glb, p, y, stabSeite) {
    const inst = glb.clone(true);
    const bx = (p.bx ?? 0) * stabSeite, by = (p.by ?? 1) * stabSeite; // zeigt zur Stabseite
    const dreh = Math.atan2(bx, -by); // lokal +Z -> Weltrichtung (bx, 0, -by)
    inst.quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), dreh);
    inst.position.copy(V({ x: p.x + bx * ECK_STAB_ANLAGE * 100, y: p.y + by * ECK_STAB_ANLAGE * 100 }, y));
    group.add(inst);
  }
  // Handlaufstütze 90° am Eckpfosten (60704-240), aus der STEP-Datei ausgemessen:
  //   lokal +Y = Pfostenachse, Y = 0 = unteres Ende des Steckzapfens, Bund bei 20,5 mm
  //   Handlaufachsen bei Y = 125,37 mm, direkt über der Pfostenachse; die beiden Auflagen zeigen
  //   in lokal +X und +Z. Das Teil ist symmetrisch zur Diagonalen (1, 0, 1).
  const ECK_STUETZE_HANDLAUF = 0.12537;
  function eckStuetzeInstanz(p, handlaufAchseY) {
    const inst = eckStuetzeGlb.clone(true);
    const wx = p.hx ?? 0, wz = -(p.hy ?? 1); // Winkelhalbierende der Handlauf-Arme in Weltkoordinaten
    inst.quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.atan2(wx, wz) - Math.PI / 4);
    inst.position.copy(V(p, handlaufAchseY - ECK_STUETZE_HANDLAUF));
    group.add(inst);
  }
  function halterInstanz(p, y, halterAbstand) {
    const inst = halterGlb.clone(true);
    inst.quaternion.setFromEuler(new THREE.Euler(1.57080, 0.00000, 0.00000, "XYZ"));
    const dreh = wandWinkel(p) + (halterAbstand < 0 ? Math.PI : 0);
    inst.quaternion.premultiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), dreh));
    inst.position.copy(V({ x: p.x + (p.nx || 0) * halterAbstand, y: p.y + (p.ny ?? 1) * halterAbstand }, y));
    group.add(inst);
  }
  function init() {
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
    renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    els.stage3d.prepend(renderer.domElement);
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(38, 1, 0.05, 200);
    // Studio-Environment prozedural (Softboxen) für Metallreflexe
    const pm = new THREE.PMREMGenerator(renderer);
    const env = new THREE.Scene(); env.background = new THREE.Color(0xdfe3e7);
    const box = (w, h, x, y, z, ry, c = 0xffffff, i = 6) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: c })); m.material.color.multiplyScalar(i); m.position.set(x, y, z); m.rotation.y = ry; m.lookAt(0, 1, 0); env.add(m); };
    box(6, 3, -5, 6, 4, 0, 0xffffff, 8); box(4, 6, 7, 3, -2, 0, 0xfff4e6, 5); box(10, 2, 0, 8, -6, 0, 0xeaf0ff, 4); box(8, 1, 0, 0.3, 8, 0, 0xffffff, 2);
    env.add(new THREE.Mesh(new THREE.SphereGeometry(30, 16, 16), new THREE.MeshBasicMaterial({ color: 0x4f5860, side: THREE.BackSide })));
    envTex = pm.fromScene(env, 0.02).texture; scene.environment = envTex; pm.dispose();
    const hemi = new THREE.HemisphereLight(0xffffff, 0x8a9096, 0.55); scene.add(hemi);
    const sun = new THREE.DirectionalLight(0xfff5e8, 2.2); sun.position.set(4, 7, 5); sun.castShadow = true;
    sun.shadow.mapSize.set(2048, 2048); sun.shadow.camera.left = sun.shadow.camera.bottom = -6; sun.shadow.camera.right = sun.shadow.camera.top = 6; sun.shadow.bias = -0.0005; scene.add(sun);
    // Materialien
    MAT.steel = new THREE.MeshStandardMaterial({ color: 0xc9ccd0, metalness: 1, roughness: 0.34 });
    MAT.rod = new THREE.MeshStandardMaterial({ color: 0xc4c8cc, metalness: 1, roughness: 0.3 });
    MAT.alu = new THREE.MeshStandardMaterial({ color: 0xd6d9dc, metalness: 0.85, roughness: 0.55 });
    MAT.concrete = new THREE.MeshStandardMaterial({ color: 0xb9bcbe, roughness: 0.95, metalness: 0 });
    MAT.plaster = new THREE.MeshStandardMaterial({ color: 0xf1efe9, roughness: 0.9 });
    MAT.floor = new THREE.MeshStandardMaterial({ color: 0xd9dcdf, roughness: 0.9 });
    MAT.black = new THREE.MeshStandardMaterial({ color: 0x222426, roughness: 0.6 });
    MAT.glasGhost = new THREE.MeshPhysicalMaterial({ color: 0xd8efe4, metalness: 0, roughness: 0.05, transparent: true, opacity: 0.22, side: THREE.DoubleSide, envMapIntensity: 1.2 });
    group = new THREE.Group(); scene.add(group);
    controls(); resize(); addEventListener("resize", resize); loop();
  }
  function controls() {
    const el = renderer.domElement; let drag = null, pinch = null;
    el.addEventListener("pointerdown", (e) => { drag = { x: e.clientX, y: e.clientY }; auto = false; el.setPointerCapture(e.pointerId); });
    el.addEventListener("pointermove", (e) => { if (!drag) return; theta -= (e.clientX - drag.x) * 0.006; phi = clamp(phi - (e.clientY - drag.y) * 0.005, 0.25, 1.45); drag = { x: e.clientX, y: e.clientY }; dirty = true; });
    el.addEventListener("pointerup", () => (drag = null)); el.addEventListener("pointercancel", () => (drag = null));
    el.addEventListener("wheel", (e) => { e.preventDefault(); radius = clamp(radius * (1 + Math.sign(e.deltaY) * 0.08), 1.2, 40); dirty = true; }, { passive: false });
    el.addEventListener("touchstart", (e) => { if (e.touches.length === 2) pinch = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); }, { passive: true });
    el.addEventListener("touchmove", (e) => { if (e.touches.length === 2 && pinch) { const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); radius = clamp(radius * (pinch / d), 1.2, 40); pinch = d; dirty = true; } }, { passive: true });
  }
  function resize() {
    if (!renderer) return;
    const w = els.stage3d.clientWidth || 600, h = els.stage3d.clientHeight || 360;
    renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); dirty = true;
  }
  function loop() {
    requestAnimationFrame(loop);
    if (els.stage3d.hidden) return;
    if (auto) { theta += 0.0025; dirty = true; }
    if (!dirty) return; dirty = false;
    camera.position.set(target.x + radius * Math.sin(phi) * Math.sin(theta), target.y + radius * Math.cos(phi), target.z + radius * Math.sin(phi) * Math.cos(theta));
    camera.lookAt(target.x, target.y, target.z);
    renderer.render(scene, camera);
  }
  // --- Geometrie-Helfer (Einheit: Meter; Plan y -> -z) ---
  const V = (p, h = 0) => new THREE.Vector3(p.x / 100, h, -p.y / 100);
  function cyl(a, b, r, mat, seg = 20) {
    const dir = new THREE.Vector3().subVectors(b, a), len = dir.length();
    if (len < 1e-4) return null;
    const m = new THREE.Mesh(new THREE.CylinderGeometry(r, r, len, seg), mat);
    m.position.copy(a).add(b).multiplyScalar(0.5);
    m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), dir.normalize());
    m.castShadow = true; group.add(m); return m;
  }
  function sphere(p, r, mat) { const m = new THREE.Mesh(new THREE.SphereGeometry(r, 18, 12), mat); m.position.copy(p); m.castShadow = true; group.add(m); return m; }
  // Rechteckiges Profil entlang einer Polylinie – Ecken als Gehrungsstoß (wie der runde Handlauf),
  // sodass Innen- und Außenkante bündig ineinanderlaufen statt sich zu überlappen.
  function mitreBar(pts, yCenter, w, h, mat) {
    const n = pts.length;
    for (let i = 0; i < n - 1; i++) {
      const a = pts[i], b = pts[i + 1], L = dist(a, b);
      if (L < 1e-3) continue;
      const len = L / 100, dx = (b.x - a.x) / L, dy = (b.y - a.y) / L;
      const tS = i > 0 ? Math.tan(knick(pts[i - 1], a, b) / 2) : 0;
      const tE = i < n - 2 ? Math.tan(knick(a, b, pts[i + 2]) / 2) : 0;
      const safe = (t) => (Math.abs(t) * w < len ? t : 0);
      const g = new THREE.BoxGeometry(w, len, h);
      const pos = g.attributes.position, sS = safe(tS), sE = safe(tE);
      for (let k = 0; k < pos.count; k++) { const x = pos.getX(k), y = pos.getY(k); pos.setY(k, y > 0 ? y - x * sE : y + x * sS); }
      pos.needsUpdate = true; g.computeVertexNormals();
      const m = new THREE.Mesh(g, mat);
      const X = new THREE.Vector3(-dy, 0, -dx), Y = new THREE.Vector3(dx, 0, -dy), Z = new THREE.Vector3().crossVectors(X, Y);
      m.quaternion.setFromRotationMatrix(new THREE.Matrix4().makeBasis(X, Y, Z));
      m.position.copy(V(a, yCenter)).add(V(b, yCenter)).multiplyScalar(0.5);
      m.castShadow = true; m.receiveShadow = true; group.add(m);
    }
  }
  function box(w, h, d, mat) { const m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat); m.castShadow = true; m.receiveShadow = true; group.add(m); return m; }
  // Signierter Knickwinkel (rad, links positiv) an p1 zwischen p0→p1 und p1→p2
  function knick(p0, p1, p2) {
    const a = Math.atan2(p1.y - p0.y, p1.x - p0.x), b = Math.atan2(p2.y - p1.y, p2.x - p1.x);
    let w = b - a; while (w > Math.PI) w -= 2 * Math.PI; while (w < -Math.PI) w += 2 * Math.PI; return w;
  }
  // Rohr entlang einer Polylinie – Ecken als Gehrungsstoß (wie der Eckverbinder: zwei Rohre auf Gehrung verschweißt)
  function tubeAlong(pts, h, r, mat) {
    const n = pts.length;
    for (let i = 0; i < n - 1; i++) {
      const a = pts[i], b = pts[i + 1], len = dist(a, b) / 100;
      const dx = (b.x - a.x) / (len * 100 || 1), dy = (b.y - a.y) / (len * 100 || 1);
      const tS = i > 0 ? Math.tan(knick(pts[i - 1], a, b) / 2) : 0;
      const tE = i < n - 2 ? Math.tan(knick(a, b, pts[i + 2]) / 2) : 0;
      const safe = (t) => (Math.abs(t) * r * 2 < len ? t : 0);
      const g = new THREE.CylinderGeometry(r, r, len, 28, 1);
      const pos = g.attributes.position, sh = { s: safe(tS), e: safe(tE) };
      for (let k = 0; k < pos.count; k++) { // Endflächen scheren = Gehrungsschnitt in der Winkelhalbierenden
        const x = pos.getX(k), y = pos.getY(k);
        pos.setY(k, y > 0 ? y - x * sh.e : y + x * sh.s);
      }
      pos.needsUpdate = true;
      const m = new THREE.Mesh(g, mat);
      const X = new THREE.Vector3(-dy, 0, -dx), Y = new THREE.Vector3(dx, 0, -dy), Z = new THREE.Vector3().crossVectors(X, Y);
      m.quaternion.setFromRotationMatrix(new THREE.Matrix4().makeBasis(X, Y, Z));
      m.position.copy(V(a, h)).add(V(b, h)).multiplyScalar(0.5);
      m.castShadow = true; group.add(m);
    }
  }
  function extrudePoly(pts2, height, mat, y0) {
    const shape = new THREE.Shape(pts2.map((p) => new THREE.Vector2(p.x / 100, p.y / 100)));
    const g = new THREE.ExtrudeGeometry(shape, { depth: height, bevelEnabled: false });
    const m = new THREE.Mesh(g, mat); m.rotation.x = -Math.PI / 2; m.position.y = y0; m.receiveShadow = true; m.castShadow = true; group.add(m); return m;
  }
  function orient(mesh, dx, dy) { mesh.rotation.y = Math.atan2(dy, dx); }

  function build(cfg, geo) {
    pending = [cfg, geo];
    load().then((ok) => {
      if (!ok || !pending) return;
      return ladeBauteile().then(() => {
        if (!pending) return;
        const [c, g] = pending; pending = null; rebuild(c, g);
      });
    });
  }
  function rebuild(cfg, geo) {
    while (group.children.length) { const c = group.children.pop(); c.geometry?.dispose(); }
    const H = (S.gelaenderhoehe || 100) / 100, typ = cfg.typ || "reling", seit = cfg.montage === "seitlich";
    const hand = typ === "handlauf";
    // Umgebung: Bodenplatte + Wand
    if (hand) {
      const fl = box(60, 0.02, 60, MAT.floor); fl.position.set(geo.gesamt / 200, -0.011, 0); fl.receiveShadow = true;
      // Wandfläche auf der Ausladung des Wandhalters (7,5 cm) – das aus dem Original-Bauteil
      // berechnete Maß deckt sich mit der bisherigen Näherung, gilt also für beide Fälle.
      const wall = box(geo.gesamt / 100 + 2, 2.6, 0.2, MAT.plaster); wall.position.set(geo.gesamt / 200, 1.3, -WANDHALTER_AUSLADUNG - 0.1);
      tubeAlong(geo.kante, 0.9, 0.0212, MAT.steel);
      endkappen(geo.kante, 0.9); // Original-Endkappen an beiden Enden des Wandhandlaufs
      if (wandhalterGlb) { geo.pfosten.forEach((p) => wandhalterInstanz(p, 0.9)); fit(geo, 0.9); return; }
      // Näherung, solange das Original-Bauteil (noch) nicht geladen werden konnte
      geo.pfosten.forEach((p) => {
        const rosCenter = V({ x: p.x, y: 7.4 }, 0.855), tubeUnter = V({ x: p.x, y: 0 }, 0.9 - 0.0212 - 0.001);
        const bogen = rosCenter.clone().lerp(tubeUnter, 0.5).add(new THREE.Vector3(0, 0.012, 0));
        const arm = new THREE.Mesh(new THREE.TubeGeometry(new THREE.QuadraticBezierCurve3(rosCenter, bogen, tubeUnter), 16, 0.008, 10, false), MAT.steel);
        arm.castShadow = true; group.add(arm);
        const ros = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.03, 0.0045, 28), MAT.steel);
        ros.rotation.x = Math.PI / 2; ros.position.copy(rosCenter); ros.position.z -= 0.001; ros.castShadow = true; group.add(ros);
        [-0.019, 0.019].forEach((off) => { // zwei Senkkopfschrauben, Abstand 19 mm von der Mitte
          const scr = new THREE.Mesh(new THREE.CylinderGeometry(0.0035, 0.0035, 0.004, 10), MAT.steel);
          scr.rotation.x = Math.PI / 2; scr.position.copy(rosCenter).add(new THREE.Vector3(off, 0, -0.003)); group.add(scr);
        });
        const sat = new THREE.Mesh(new THREE.CylinderGeometry(0.023, 0.023, 0.03, 18, 1, true, Math.PI, Math.PI), MAT.steel);
        sat.position.copy(V({ x: p.x, y: 0 }, 0.9)); sat.rotation.z = Math.PI / 2; sat.castShadow = true; group.add(sat);
      });
      fit(geo, 0.9); return;
    }
    // Betonplatte in der 3D-Ansicht: Sie wird um "ueberstand" über die angegebene Außenkante hinaus
    // und an den Enden verlängert gezeichnet. Grund: Die Pfostenachse liegt nur 6 cm hinter der
    // Außenkante, die Fußplatte ist 10,5 cm breit – ohne Überstand stünden die Pfosten optisch auf
    // der Kante (nur 7,5 mm Rand). Das ist reine Darstellung; das Maß, das der Kunde angibt, und
    // alle berechneten Längen bleiben unverändert die Außenkante.
    const ueberstand = Math.max(0, Number(S.bodenplatteUeberstand ?? 20));
    // Nach VORN darf die Platte nur bei aufgeschraubter Montage über die Außenkante hinausragen.
    // Bei seitlicher Montage sitzt der Pfosten außerhalb der Kante (Achsversatz -7 cm) und hängt an
    // der Stirnseite – ein Überstand würde ihn verschlucken, er stünde dann auf der Platte statt
    // davor. An den ENDEN (längs des Geländers) wird dagegen in beiden Fällen verlängert.
    const vornUeberstand = seit ? 0 : ueberstand;
    const aussen = vornUeberstand || ueberstand
      ? endenVerlaengern(offsetPolyline(geo.kante, -vornUeberstand), ueberstand)
      : geo.kante;
    const innen = endenVerlaengern(offsetPolyline(geo.kante, geo.tiefe), ueberstand);
    const wand = endenVerlaengern(offsetPolyline(geo.kante, geo.tiefe + 24), ueberstand);
    // Stärke der dargestellten Betonplatte: 25 cm. Bei seitlicher Montage reicht die Anschraubplatte
    // des Pfostens bis 22,6 cm unter die Oberkante – mit den früheren 20 cm hätte sie unten überstanden.
    const plattenStaerke = 0.25;
    extrudePoly([...aussen, ...innen.slice().reverse()], plattenStaerke, MAT.concrete, -plattenStaerke);
    extrudePoly([...innen, ...wand.slice().reverse()], 2.5, MAT.plaster, 0);
    const ground = box(80, 0.02, 80, MAT.floor); ground.position.y = -3.01; ground.receiveShadow = true;

    if (typ === "ganzglas") {
      const y0 = seit ? -0.15 : 0, ph = 0.13, pw = 0.062;
      mitreBar(geo.linie, y0 + ph / 2, pw, ph, MAT.alu); // Bodenprofil, Ecken auf Gehrung – bündiger Stoß statt Überlappung
      geo.segs.forEach((sg) => {
        if (seit) sg.pts.forEach((p) => { const an = box(0.03, 0.12, 0.05, MAT.steel); an.position.copy(V({ x: p.x + sg.nx * 3.5, y: p.y + sg.ny * 3.5 }, -0.09)); orient(an, sg.nx, sg.ny); });
        const gy0 = y0 + 0.02, gh = H - 0.02 - gy0;
        for (let k = 0; k < sg.felder; k++) {
          const w = sg.feldLaenge / 100 - 0.01, cx = (sg.pts[k].x + sg.pts[k + 1].x) / 2, cy = (sg.pts[k].y + sg.pts[k + 1].y) / 2;
          const g = box(w, gh, 0.0175, MAT.glasGhost); g.castShadow = false; g.position.copy(V({ x: cx, y: cy }, gy0 + gh / 2)); orient(g, sg.dx, sg.dy);
        }
      });
      if (cfg.handlauf === "eckig") geo.segs.forEach((sg, i) => {
        const vs = i > 0 ? 2 : 0, ve = i < geo.segs.length - 1 ? 2 : 0; // an Ecken je 2 cm verlängern → geschlossene Gehrungsecke
        const hb = box((sg.len + vs + ve) / 100, 0.04, 0.04, MAT.steel);
        hb.position.copy(V({ x: (sg.a.x + sg.b.x) / 2 + sg.dx * (ve - vs) / 2, y: (sg.a.y + sg.b.y) / 2 + sg.dy * (ve - vs) / 2 }, H - 0.02)); orient(hb, sg.dx, sg.dy);
      });
      else tubeAlong(geo.linie, H - 0.0212, 0.0212, MAT.steel);
      fit(geo, H); return;
    }
    // Pfostengeländer
    // Reling/Reling-PLUS: Original-Pfosten 40511-240 (Bodenplatte + Rohr, 5 Anschraubpunkte) bei
    // aufgeschraubter Montage, sonst parametrische Näherung. Handlauf sitzt auf der Handlaufstütze
    // 60722-240 (Original-Bauteil, falls geladen); Reling-PLUS hat seine eigene abgewinkelte Stütze.
    // WICHTIG: Der Ursprung der Original-Handlaufstütze ist die Stiftspitze (unten), nicht die
    // Handlaufauflage (oben) — die Platte liegt 0,10652 m ÜBER dem Ursprung. Der Ursprung muss also
    // auf "postTop" sitzen (= Stiftspitzen-Höhe), damit die Platte automatisch exakt auf topY landet.
    const R = 0.0212, topY = H - R, stuetzeH = typ === "relingplus" ? 0 : 0.1065;
    // Optische "Versenkung": Der Original-Pfosten wird beim Rendern etwas höher gezogen als postTop,
    // damit die Stiftspitze sichtbar im Pfosten verschwindet statt nur oben aufzusitzen. Betrifft nur
    // die Darstellung des Pfostens, nicht die Stütze (deren Ursprung bleibt exakt bei postTop).
    // stuetzeHoehenkorrektur: minimale Feinkorrektur (nur bei echter Reling mit Original-Stütze),
    // damit die Platte exakt unter dem unverändert bei H bleibenden Handlauf liegt. Beide Werte per
    // Kalibrierungs-Tool bestätigt (demo/kalibrierung-pfosten-stuetze.html).
    const stuetzeVersenkung = 0.020;
    const stuetzeHoehenkorrektur = typ === "relingplus" ? 0 : 0.0017;
    // postTop = Höhe der Stiftspitze der Handlaufstütze. Das Pfostenrohr reicht darüber hinaus bis
    // postTopGlb – dort steckt der Stift 20 mm im Rohr. Beide Pfostenarten werden deshalb bis
    // postTopGlb gezeichnet, und die Gewindehöhen beziehen sich ebenfalls darauf, damit die
    // Querstäbe genau auf den Bohrungen des Original-Pfostens sitzen.
    const postTop = topY - stuetzeH + stuetzeHoehenkorrektur;
    // Reling-PLUS hat keine Handlaufstütze, sondern den Handlaufhalter 50372-240: Der Handlauf liegt
    // 60 mm über der Pfostenoberkante und 9 cm zur Gebäudeseite versetzt (Kalibrierungs-Tool).
    const PLUS_HANDLAUF_HOEHE = 0.060, PLUS_HANDLAUF_QUER = 9;
    const postTopGlb = typ === "relingplus" ? H - PLUS_HANDLAUF_HOEHE : postTop + stuetzeVersenkung;
    geo.pfosten.forEach((p) => {
      const base = V(p, 0);
      if (seit && p.ecke) {
        // Wird derzeit nicht erreicht: Bei seitlicher Montage stehen keine Pfosten mehr auf der Ecke.
        // Bleibt erhalten, falls der Eckhalter 60201-240E später wieder genutzt werden soll.
        cyl(V(p, postTopGlb - PFOSTEN_SEITLICH_LAENGE), V(p, postTopGlb), R, MAT.steel);
        if (eckHalterGlb) eckHalterInstanz(p);
      } else if (seit && pfostenSeitlichGlb[stabAnzahl(cfg)]) {
        pfostenSeitlichInstanz(pfostenSeitlichGlb[stabAnzahl(cfg)], p, postTopGlb);
      } else if (seit) { // Näherung, solange das Original-Bauteil (noch) nicht geladen werden konnte
        cyl(V(p, -0.3), V(p, postTop), R, MAT.steel);
        const pl = box(0.012, 0.16, 0.08, MAT.steel); pl.position.copy(V({ x: p.x - p.nx * (geo.d), y: p.y - p.ny * geo.d }, -0.1)); orient(pl, p.nx, p.ny);
        [-0.06, -0.14].forEach((h) => cyl(V(p, h), V({ x: p.x - p.nx * geo.d, y: p.y - p.ny * geo.d }, h), 0.012, MAT.steel, 12));
      } else if (pfostenGlb) {
        pfostenInstanz(p, postTopGlb);
      } else {
        cyl(base, V(p, postTop), R, MAT.steel);
        const bp = new THREE.Mesh(new THREE.CylinderGeometry(0.05, 0.05, 0.008, 28), MAT.steel); bp.position.copy(V(p, 0.004)); bp.castShadow = true; group.add(bp);
      }
      if (stuetzeH > 0) {
        if (!seit && p.ecke && eckStuetzeGlb) eckStuetzeInstanz(p, H); // Handlaufstütze 90° am Eckpfosten
        else if (stuetzeGlb) stuetzeInstanz(p, postTop); // Original-Bauteil; Ursprung = Stiftspitze, Platte landet automatisch auf topY
        else { // Näherung, solange das Bauteil (noch) nicht geladen werden konnte
          cyl(V(p, postTop), V(p, topY - 0.004), 0.0095, MAT.steel, 14);
          const platte = new THREE.Mesh(new THREE.CylinderGeometry(0.022, 0.022, 0.006, 22), MAT.steel);
          platte.rotation.x = Math.PI / 2; platte.position.copy(V(p, topY - 0.003)); platte.castShadow = true; group.add(platte);
        }
      }
    });
    const hlLine = typ === "relingplus" ? offsetPolyline(geo.linieHL, PLUS_HANDLAUF_QUER) : geo.linieHL;
    tubeAlong(hlLine, H, R, MAT.steel);
    endkappen(hlLine, H); // Original-Endkappen an beiden Handlaufenden
    if (typ === "relingplus") geo.pfosten.forEach((p) => {
      if (plusHalterGlb) plusHalterInstanz(p, postTopGlb);
      else cyl(V(p, postTopGlb), V({ x: p.x + p.nx * PLUS_HANDLAUF_QUER, y: p.y + p.ny * PLUS_HANDLAUF_QUER }, H - 0.005), 0.009, MAT.steel, 12);
    });
    {
      // Querstäbe laufen NICHT zwischen den Pfosten, sondern durchgehend davor – auf der
      // Gebäudeseite, befestigt mit Querstabhaltern an den Pfostenbohrungen. Abstände per
      // Kalibrierungs-Tool bestätigt (demo/kalibrierung-pfosten-stuetze.html).
      // Vorzeichen: aufgeschraubt liegen die Gewinde zur Gebäudeseite (+), bei seitlicher Montage
      // zeigt die Anschraubplatte dorthin und die Gewinde nach außen (-). Siehe pfostenSeitlichInstanz().
      const stabSeite = seit ? -1 : 1;
      const stabAbstand = 4.3 * stabSeite;   // cm, Querstabachse seitlich versetzt zur Pfostenachse
      const halterAbstand = 2.6 * stabSeite; // cm, Sitz des Halters zwischen Pfosten und Querstab
      const hs = stabHoehenAbsolut(stabAnzahl(cfg), postTopGlb);
      const stabLinie = offsetPolyline(geo.linieHL, stabAbstand);
      hs.forEach((h) => tubeAlong(stabLinie, h, 0.006, MAT.rod));
      geo.pfosten.forEach((p) => {
        // Eckpfosten (nur Aufbodenmontage): Querstabhalter 90°. Liegen die Stäbe auf der Innenseite
        // des Knicks, ist es die Außenecken-Ausführung (AE), sonst die Innenecken-Ausführung (IE).
        const eckGlb = !seit && p.ecke ? ((p.eckWinkel ?? 90) >= 0) === (stabSeite > 0) ? eckStabAeGlb : eckStabIeGlb : null;
        if (eckGlb) hs.forEach((h) => eckStabHalterInstanz(eckGlb, p, h, stabSeite));
        else if (halterGlb) hs.forEach((h) => halterInstanz(p, h, halterAbstand));
      });
    }
    fit(geo, H);
  }
  function fit(geo, H) {
    const pts = geo.linie.map((p) => V(p, 0));
    const b = new THREE.Box3().setFromPoints(pts); b.max.y = H;
    const c = b.getCenter(new THREE.Vector3()), size = b.getSize(new THREE.Vector3());
    target = { x: c.x, y: H * 0.45, z: c.z + 0.15 };
    radius = clamp(Math.max(size.x, size.z, 2) * 0.95 + 1.6, 2.6, 30); dirty = true;
  }
  return { build, resize };
})();

/* ----------------------------------------------------------------
   8. Warenkorb (Shopify Cart-API)
   ---------------------------------------------------------------- */
function eigenschaften(cfg, geo, id, voll) {
  const p = { Konfiguration: id };
  if (!voll) return p;
  schritte(cfg).filter((s) => s.id !== "fertig").forEach((s) => { const v = zusammenfassungWert(s.id, cfg, geo); if (v) p[s.title] = v; });
  p["Geländerlänge"] = fmtM(geo.gesamt);
  if (cfg.typ === "ganzglas") p["Glas (bauseits)"] = glasliste(cfg, geo).list.map((g) => `Seite ${g.seite}: ${g.anzahl}× ca. ${g.breite}×${g.hoehe} cm`).join("; ");
  else if (cfg.typ !== "handlauf") p["Pfosten"] = String(geo.pfosten.length);
  // Früher: Vermerk "Eckhalter 60201-240E" bei seitlicher Montage. Entfällt, seit dort keine
  // Pfosten mehr auf der Ecke stehen (Pfosten vor und hinter der Ecke).
  p["Maße bestätigt"] = "ja";
  const daten = b64url(JSON.stringify(cfg));
  p["_eo24"] = daten;
  // Link, mit dem sich die Konfiguration im Adminbereich wieder öffnen lässt – dort sind dann die
  // 3D-Ansicht und die berechnete Stückliste zu sehen. Der Unterstrich blendet die Eigenschaft im
  // Warenkorb und an der Kasse aus; in der Bestellung im Shopify-Adminbereich bleibt sie sichtbar.
  const seite = (S.konfiguratorSeite || "").trim();
  if (seite) {
    const basis = /^https?:\/\//i.test(seite) ? seite : location.origin + (seite.startsWith("/") ? "" : "/") + seite;
    p["_3D-Ansicht"] = basis + (basis.includes("?") ? "&" : "?") + "eo24=" + daten;
  }
  return p;
}
async function inDenWarenkorb() {
  const cfg = state.cfg, geo = berechneGeometrie(cfg), bom = stueckliste(cfg, geo), id = konfigId(cfg), sum = gesamtpreis(bom);
  if (!cfg.bestaetigt) return;
  // Zweite Sicherung neben dem gesperrten Button: Solange für ein Bauteil kein Shop-Preis vorliegt,
  // wäre die Summe aus Code-Richtpreisen gebildet. Dann lieber nicht bestellen lassen.
  const ohnePreis = S.shop ? bom.filter((p) => p.geladen && !p.ok) : [];
  if (ohnePreis.length) {
    state.fehler = "Der Preis konnte nicht verbindlich ermittelt werden. Bitte laden Sie die Seite neu oder wenden Sie sich an uns.";
    renderSteps();
    return;
  }
  state.sende = true; state.fehler = ""; renderSteps();
  try {
    if (!S.shop) { // Demo-Modus
      const payload = bom.map((p, i) => ({ handle: handleFuer(p.key), quantity: p.menge, properties: eigenschaften(cfg, geo, id, i === 0) }));
      await new Promise((r) => setTimeout(r, 500));
      alert("Demo-Modus – im Shop würde jetzt Folgendes in den Warenkorb gelegt:\n\n" + JSON.stringify(payload, null, 2).slice(0, 1500) + "\n…");
      state.sende = false; renderSteps(); return;
    }
    await Promise.all(bom.map((p) => ladePreis(p.key)));
    let items;
    const bom2 = stueckliste(cfg, geo); // nach dem Laden neu bewerten (Varianten-IDs, Lieferlängen)
    const alleDa = bom2.every((p) => p.ok && p.variantId);
    if (S.cartMode === "stueckliste" && alleDa) {
      items = bom2.map((p, i) => ({ id: p.variantId, quantity: p.menge, properties: eigenschaften(cfg, geo, id, i === 0) }));
    } else {
      await ladePreis("konfigurator_produkt");
      if (!PREISE.konfigurator_produkt?.ok) throw new Error("Bestellung nicht möglich: Bauteile fehlen im Shop und es ist kein Konfigurator-Produkt („" + handleFuer("konfigurator_produkt") + "“) angelegt.");
      const einheit = PREISE.konfigurator_produkt.cents || 100;
      const props = eigenschaften(cfg, geo, id, true);
      props["Stückliste"] = bom.map((p) => `${p.menge}× ${p.name}`).join("; ");
      props["Preis"] = fmtEuro(sum);
      items = [{ id: PREISE.konfigurator_produkt.variantId, quantity: Math.max(1, Math.round(sum / einheit)), properties: props }];
    }
    const r = await fetch(S.cartAddUrl || "/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || "Warenkorb-Fehler " + r.status);
    location.href = S.cartUrl || "/cart";
  } catch (err) {
    state.fehler = err.message || String(err); state.sende = false; renderSteps();
  }
}

/* ----------------------------------------------------------------
   9. Entwurf sichern / wiederherstellen
   ---------------------------------------------------------------- */
function entwurfUrl(cfg) {
  const u = new URL(location.href); u.searchParams.set("eo24", b64url(JSON.stringify(cfg))); return u.toString();
}
function entwurfLaden() {
  const raw = new URL(location.href).searchParams.get("eo24");
  if (!raw) return false;
  try {
    const c = JSON.parse(unb64url(raw));
    if (!PRODUKTE.some((p) => p.id === c.typ)) return false;
       if (c.form && !FORMEN.some((f) => f.id === c.form)) return false;
    state.cfg = { ...DEFAULT_CFG(), ...c, bestaetigt: false, segmente: (c.segmente || []).map((s) => ({ l: clamp(Number(s.l) || 300, 30, 3000), w: clamp(Number(s.w) || 90, -170, 170) })) };
    if (!state.cfg.segmente.length) state.cfg.segmente = [{ l: 300, w: 90 }];
    const list = schritte(state.cfg);
    state.done = new Set(list.map((s) => s.id).filter((x) => !["masse", "fertig"].includes(x)));
    state.open = "masse"; state.confirming = false;
    return true;
  } catch { return false; }
}

/* ----------------------------------------------------------------
   10. Start
   ---------------------------------------------------------------- */
function start() {
  if (!ROOT) return;
  try { Object.assign(S, JSON.parse(ROOT.querySelector("[data-eo24-settings]").textContent)); } catch (e) { console.warn("EO24: Einstellungen ungültig (JSON in der Section prüfen)", e); Object.assign(S, { shop: false }); }
  if (typeof S.lieferlaengen === "string") S.lieferlaengen = S.lieferlaengen.split(/[,;\s]+/).map(Number).filter((x) => x > 0);
  shell();
  entwurfLaden();
  update();
  // Vorab laden, damit der erste Preis schnell steht (Standard: 5 Gewinde, aufgeschraubt)
  if (S.shop) ["handlaufrohr", "pfosten_boden_5g", "konfigurator_produkt"].forEach(ladePreis);
}
window.EO24 = { KOMPONENTEN, PRODUKTE, berechneGeometrie, stueckliste, glasliste, zuschnittPlan, offsetPolyline, konfigId, state, settings: S, handleFuer };
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
